<template>
  <div>
    <v-container fluid>
      <v-overlay
        v-model="showSuccess"
        :scrim="true"
        opacity="0.3"
        persistent
        :z-index="9900"
      >
      </v-overlay>
      <transition name="fade-slide">
        <output v-if="showSuccess" class="success-toast">
          <img src="@/assets/mdi_success-bold.svg" alt="img" width="20" height="20" />
          <span style="font-size: 15px; font-weight: 600;">{{ successMessage }}</span>
        </output>
      </transition>

      <div class="main-card">
        <div class="action-bar">
          <div>
            <h2 style="font-weight: 600; color: #171717;">{{ $t("llmsManagement") }}</h2>
          </div>
          <div class="d-flex justify-start align-center" style="gap: 10px;">
            <v-text-field
              :placeholder="$t('searchPlatformProviderModel')"
              variant="none"
              density="comfortable"
              hide-details
              class="search-section"
              v-model="searchKeyword"
              @keydown.enter="Search"
            >
              <template #prepend-inner>
                <img
                  class="search-icon"
                  src="@/assets/flowbite_search-outline.svg"
                  alt="Search"
                  width="20"
                  height="20"
                />
              </template>
            </v-text-field>

            <div class="action-divider"></div>
  
            <button type="button"
              id="button-add-modeldata"
              color="grey"
              class="products-header-button"
              variant="elevated"
              @click="Add()"
            >
              <img src="@/assets/ic_round-plus.svg" alt="img" width="20" height="20" />
              <span style="color: #ffffff; font-size: 14px;">{{ $t("addModel") }}</span>
            </button>
          </div>
        </div>
  
        <div>
          <v-data-table-server
            :items="listDataModel"
            :headers="headers"
            :items-per-page="options.itemsPerPage"
            :items-length="searchTotalTable"
            v-model:options="options"
            class="mt-4"
            :loading="dialog"
            :loading-text="$t('loadingModels')"
          >
            <template v-slot:bottom>
              <div class="d-flex justify-space-between align-center px-4 py-2" style="width: 100%">
                <div>{{ $t("totalResults") }} {{ searchTotalTable }}</div>

                <v-data-table-footer
                  :items="[
                    { text: '10', value: 10 },
                    { text: '25', value: 25 },
                    { text: '50', value: 50 },
                    { text: '100', value: 100 },
                    { text: 'All', value: -1 },
                  ]"
                  :page="options.page"
                  :length="Math.ceil(searchTotalTable / itemsPerPage)"
                />
              </div>
            </template>

            <template #no-data>
              <div style="text-align: center;">
                <span style="color: #646464; font-weight: 400;">{{ $t("noDataAvailable") }}</span>
              </div>
            </template>
            <!-- Custom row template -->
            <template v-slot:item="{ item, index }">
              <tr class="table-row">
                <td style="text-align: left">
                  <div>
                    {{ (options.page - 1) * itemsPerPage + (index + 1) }}
                  </div>
                </td>
                <td style="text-align: left">
                  <span class="provider-name">{{ item.platform || "-" }}</span>
                </td>
                <td style="text-align: left">
                  <span class="provider-name">{{ item.provider }}</span>
                </td>
                <td style="text-align: left">
                    <span class="provider-name">{{ item.modelDisplay }}</span>
                </td>
                <td style="text-align: left">
                  <code class="provider-name">{{ item.modelName }}</code>
                </td>
                <td style="text-align: left">
                  <span class="provider-name">{{ item.apiVersion || "-" }}</span>
                </td>
                <td class="text-center">
                  <div
                    class="model-type-badge"
                    :class="getModelTypeClass(item.modelType)"
                  >
                    <img :src="item.modelType === 'text_based' ? textModelTypeIcon : imageModelTypeIcon" alt="img" width="14" height="14" />
                    <span style="font-size: 12px">
                      {{
                        item.modelType === "text_based"
                          ? $t('textBased')
                          : $t('textToImage')
                      }}
                    </span>
                  </div>
                </td>
                <td style="text-align: center">
                  <div class="price-display">
                    <template v-if="item.modelType === 'text_based'">
                      <div class="price-row">
                        <v-tooltip location="top" max-width="400px">
                          <template v-slot:activator="{ props }">
                            <div class="price-item input" v-bind="props">
                              <v-icon size="12" color="success"
                                >mdi-arrow-down</v-icon
                              >
                              <span style="color: #2ABF56;">{{ item.promptPriceUSD }}</span>
                            </div>
                          </template>
                          <span>{{ $t('inputPrice') }}</span>
                        </v-tooltip>

                        <v-tooltip location="top" max-width="400px">
                          <template v-slot:activator="{ props }">
                            <div class="price-item output" v-bind="props">
                              <v-icon size="12" color="info">mdi-arrow-up</v-icon>
                              <span style="color: #3859D0;">{{ item.completionPriceUSD }}</span>
                            </div>
                          </template>
                          <span>{{ $t('outputPrice') }}</span>
                        </v-tooltip>
                      </div>
                      <div class="price-unit">{{ $t("per1kTokens") }}</div>
                    </template>
                    <template v-else>
                      <div class="price-row">
                        <v-tooltip location="top" max-width="400px">
                          <template v-slot:activator="{ props }">
                            <div class="price-item image" v-bind="props">
                              <img src="@/assets/fi-rr-picture-green.svg" alt="img" width="18" height="18" />
                              <span style="color: #2ABF56;">{{ item.imagePriceUSD }}</span>
                            </div>
                          </template>
                          <span>{{ $t('imageOutputPrice') }}</span>
                        </v-tooltip>
                      </div>
                      <div class="price-unit">{{ $t("perImage") }}</div>
                    </template>
                  </div>
                </td>
                <td style="text-align: left">
                  <div class="action-group" style="justify-content: center">
                    <!-- Edit -->
                     <button
                        type="button"
                        id="button-edit-modeldata" 
                        variant="text"
                        density="comfortable"
                        @click="Edit(item)"
                        icon
                      >
                        <v-tooltip location="top" max-width="230px">
                          <template v-slot:activator="{ props }">
                            <img
                              v-bind="props"
                              src="@/assets/Edit.svg"
                              alt="img"
                              width="20"
                              height="20"
                              style="cursor: pointer; margin-left: 4px;"
                            />
                          </template>
                          <span>{{ $t('edit') }}</span>
                        </v-tooltip>
                      </button>
  
                    <!-- Delete -->
                     <button
                        type="button"
                        id="button-delete-modeldata"
                        variant="text"
                        density="comfortable"
                        @click="openDeleteDialog(item)"
                      >
                        <v-tooltip location="top" max-width="230px">
                          <template v-slot:activator="{ props }">
                            <img
                              v-bind="props"
                              src="@/assets/Group.svg"
                              alt="img"
                              width="20"
                              height="17"
                              style="cursor: pointer; margin-left: 4px;"
                            />
                          </template>
                          <span>{{ $t('delete') }}</span>
                        </v-tooltip>
                      </button>
                  </div>
                </td>
              </tr>
            </template>
          </v-data-table-server>
        </div>
      </div>
    </v-container>

    <!-- Model Add Dialog -->
    <v-dialog v-model="AdddialogUser" max-width="1000px" persistent>
      <v-card>
        <!-- Dialog Header -->
        <div class="header-text-content">
          <h2 class="dialog-header-title"> {{ $t("addNewModel") }} </h2>
          <p class="dialog-text">{{ $t("_addNewModelSubtitle") }}</p>
        </div>
        <div>
          <hr>
        </div>

        <!-- Dialog Content -->
        <div class="dialog-body">
          <v-form ref="addForm" v-model="formValid">
            <!-- Basic Information -->
            <div class="form-section">
              <div class="d-flex align-center flex-start gap-2">
                <img src="@/assets/streamline-block_basic-ui-link.svg" alt="img" width="18" height="18" />
                <span class="section-title">{{ $t("basicInformation") }}</span>
              </div>
              <v-row class="mt-2" dense>
                <v-col cols="12" sm="12" md="6">
                  <div class="d-flex align-center flex-start gap-2">
                    <label for="">{{ $t("platform") }}</label>
                    <span class="text-error">*</span>
                    <v-tooltip location="top" max-width="400px">
                      <template v-slot:activator="{ props }">
                        <img
                          v-bind="props"
                          src="@/assets/intent group toolip.svg"
                          alt="info"
                          width="18"
                          height="18"
                        />
                      </template>
                      <span>{{ $t("_tipHostingPlatform") }}</span>
                    </v-tooltip>
                  </div>
                  <v-autocomplete
                    id="add-field-platform-modeldata"
                    v-model="currentPlatform"
                    :items="platformOptions"
                    item-title="text"
                    item-value="value"
                    :placeholder="$t('selectPlatform')"
                    persistent-placeholder
                    variant="none"
                    density="comfortable"
                    :rules="rules.required"
                    @update:model-value="changePlatform"
                    class="model-input-control mt-1"
                    clearable
                  >
                  </v-autocomplete>
                </v-col>

                <!-- Model Provider -->
                <v-col cols="12" sm="12" md="6">
                  <div class="d-flex align-center flex-start gap-2">
                    <label for="">{{ $t("modelProvider") }}</label>
                    <span class="text-error">*</span>
                    <v-tooltip location="top" max-width="400px">
                      <template v-slot:activator="{ props }">
                        <img
                          v-bind="props"
                          src="@/assets/intent group toolip.svg"
                          alt="info"
                          width="18"
                          height="18"
                        />
                      </template>
                      <span>{{ $t("_tipModelProviderOrg") }}</span>
                    </v-tooltip>
                  </div>
                  <v-autocomplete
                    id="add-field-provider-modeldata"
                    v-model="currentProvider"
                    :items="filteredProviderOptions"
                    item-title="providerName"
                    item-value="providerName"
                    :placeholder="$t('selectModelProvider')"
                    persistent-placeholder
                    variant="none"
                    density="comfortable"
                    :rules="rules.required"
                    :disabled="isModelProviderAutoFilled"
                    @update:model-value="changeProvider"
                    class="model-input-control mt-1"
                    clearable
                  >
                  </v-autocomplete>
                </v-col>

                <v-col cols="12" sm="12" md="6">
                  <div class="d-flex align-center justify-start gap-2">
                    <label for="">{{ $t("modelType") }}</label>
                    <span class="text-error">*</span>
                    <v-tooltip location="top" max-width="300px">
                      <template v-slot:activator="{ props }">
                        <img
                          v-bind="props"
                          src="@/assets/intent group toolip.svg"
                          alt="info"
                          width="18"
                          height="18"
                        />
                      </template>
                      <span>{{ $t("_tipModelTypeClassification") }}</span>
                    </v-tooltip>
                  </div>
                  <v-autocomplete
                    id="add-field-modeltype-modeldata"
                    v-model="currentModelType"
                    :items="modelTypes"
                    item-title="typeName"
                    item-value="typeValue"
                    :placeholder="$t('selectModelType')"
                    variant="none"
                    density="comfortable"
                    :rules="rules.required"
                    class="model-input-control mt-1"
                    clearable
                  >
                  </v-autocomplete>
                </v-col>
              </v-row>
            </div>
            <div class="mt-6">
              <hr>
            </div>

            <!-- Model Details -->
            <div class="form-section mt-6">
              <div class="d-flex align-center flex-start gap-2">
                <img src="@/assets/config.svg" alt="img" width="18" height="18" />
                <span class="section-title">{{ $t("modelConfiguration") }}</span>
              </div>
              <v-row class="mt-2" dense>
                <v-col cols="12" sm="12" md="6">
                  <div class="d-flex align-center flex-start gap-2">
                    <label for="Display Name">{{ $t("displayName") }}</label>
                    <span class="text-error">*</span>
                    <v-tooltip location="top" max-width="230px">
                      <template v-slot:activator="{ props }">
                        <img
                          v-bind="props"
                          src="@/assets/intent group toolip.svg"
                          alt="info"
                          width="18"
                          height="18"
                        />
                      </template>
                      <span>{{ $t("_tipDisplayNameVisible") }}</span>
                    </v-tooltip>
                  </div>
                  <v-text-field
                    id="add-field-displayname-modeldata"
                    v-model="currentModelDisplay"
                    :placeholder="$t('enterDisplayName')"
                    variant="none"
                    density="comfortable"
                    :rules="rules.required"
                    class="model-input-control mt-1"
                  >
                  </v-text-field>
                </v-col>

                <v-col cols="12" sm="12" md="6">
                  <div class="d-flex align-center flex-start gap-2">
                    <label for="Model Name">{{ $t("modelName") }}</label>
                    <span class="text-error">*</span>
                    <v-tooltip location="top" max-width="230px">
                      <template v-slot:activator="{ props }">
                        <img
                          v-bind="props"
                          src="@/assets/intent group toolip.svg"
                          alt="info"
                          width="18"
                          height="18"
                        />
                      </template>
                      <span>{{ $t("_tipModelNameTechnical") }}</span>
                    </v-tooltip>
                  </div>
                  <v-text-field
                    id="add-field-modelname-modeldata"
                    v-model="currentModelName"
                    :placeholder="$t('enterModelName')"
                    variant="none"
                    density="comfortable"
                    :rules="rules.required"
                    class="model-input-control mt-1"
                  >
                  </v-text-field>
                </v-col>

                <v-col v-if="showApiVersionField" cols="12" sm="12" md="6" class="mt-2">
                  <div class="d-flex align-center flex-start gap-2">
                    <label for="API Version">{{ $t("apiVersion") }}</label>
                    <span class="text-error">*</span>
                    <v-tooltip location="top" max-width="230px">
                      <template v-slot:activator="{ props }">
                        <img
                          v-bind="props"
                          src="@/assets/intent group toolip.svg"
                          alt="info"
                          width="18"
                          height="18"
                        />
                      </template>
                      <span>{{ $t("_tipApiVersionRelease") }}</span>
                    </v-tooltip>
                  </div>
                  <v-text-field
                    id="add-field-currentAPIversion-modeldata"
                    v-model="currentAPIVesion"
                    placeholder="eg.,2025-06-12"
                    variant="none"
                    density="comfortable"
                    class="model-input-control mt-1"
                  >
                  </v-text-field>
                </v-col>

                <v-col cols="12" sm="12" md="6" class="mt-2">
                  <div class="d-flex align-center flex-start gap-2">
                    <label for="Max Token">{{ $t("maxToken") }}</label>
                    <span class="text-error">*</span>
                    <v-tooltip location="top" max-width="230px">
                      <template v-slot:activator="{ props }">
                        <img
                          v-bind="props"
                          src="@/assets/intent group toolip.svg"
                          alt="info"
                          width="18"
                          height="18"
                        />
                      </template>
                      <span>{{ $t("_tipMaxTokenLimit") }}</span>
                    </v-tooltip>
                  </div>
                  <v-text-field
                    id="add-field-maxToken-modeldata"
                    v-model="maxToken"
                    placeholder="1"
                    variant="none"
                    density="comfortable"
                    class="model-input-control mt-1 model-number-spinner"
                    type="number"
                    min="0"
                    @keydown="preventNegative"
                  >
                    <template #append-inner>
                      <div class="number-arrows">
                        <v-btn
                          type="button"
                          variant="text"
                          size="x-small"
                          @click.stop="adjustMaxToken(1)"
                        >
                          <img src="@/assets/number-up.svg" alt="up" width="10" height="10" />
                        </v-btn>
                        <v-btn
                          type="button"
                          variant="text"
                          size="x-small"
                          @click.stop="adjustMaxToken(-1)"
                        >
                          <img src="@/assets/number-down.svg" alt="down" width="10" height="10" />
                        </v-btn>
                      </div>
                    </template>
                  </v-text-field>
                </v-col>
                <v-col cols="12" sm="12" md="6" class="mt-2">
                  <div class="d-flex align-center flex-start gap-2">
                    <label for="add-field-llmTimeout-modeldata">{{ $t("timeoutResponse") }}</label>
                    <v-tooltip location="top" max-width="280px">
                      <template v-slot:activator="{ props }">
                        <img
                          v-bind="props"
                          src="@/assets/intent group toolip.svg"
                          alt="info"
                          width="18"
                          height="18"
                        />
                      </template>
                      <span>{{ $t("_tipTimeoutResponse") }}</span>
                    </v-tooltip>
                  </div>
                  <v-text-field
                    id="add-field-llmTimeout-modeldata"
                    v-model.number="LlmTimeout"
                    :placeholder="$t('timeoutResponseSeconds')"
                    variant="outlined"
                    density="comfortable"
                    class="model-input-control mt-1"
                    type="number"
                    step="0.01"
                    min="1"
                    max="3600"
                    clearable
                    :hint="$t('_hintTimeoutResponse')"
                    persistent-hint
                    :error-messages="errorMessage.LlmTimeout.message"
                    :error="errorMessage.LlmTimeout.error"
                    @keypress="isPositiveDecimal($event)"
                    @update:model-value="clearLlmTimeoutError"
                  />
                </v-col>
              </v-row>
              <div class="mt-6">
                <hr>
              </div>

              <!-- Additional fields for Other platform -->
              <div v-if="currentPlatform === 'Other'" class="d-flex align-center flex-start gap-2 mt-4">
                <img src="@/assets/icon-park-outline_endpoint-displacement.svg" alt="img" width="18" height="18" />
                <span class="section-title">{{ $t("endpointUrl") }}</span>
              </div>
              <v-row v-if="currentPlatform === 'Other'" class="mt-1" dense>
                <v-col cols="12" sm="12" md="12">
                  <div class="d-flex align-center flex-start gap-2">
                    <label for="Endpoint URL">{{ $t("endpointUrl") }}</label>
                    <span class="text-error">*</span>
                    <v-tooltip location="top" max-width="400px">
                      <template v-slot:activator="{ props }">
                        <img
                          v-bind="props"
                          src="@/assets/intent group toolip.svg"
                          alt="info"
                          width="18"
                          height="18"
                        />
                      </template>
                      <span>{{ $t("_tipEndpointUrlTarget") }}</span>
                    </v-tooltip>
                  </div>
                  <v-text-field
                    id="add-field-endpointURL-modeldata"
                    v-model="EndPointURL"
                    :placeholder="$t('endpointUrl')"
                    variant="none"
                    density="comfortable"
                    :rules="rules.required"
                    class="model-input-control mt-1"
                  >
                  </v-text-field>
                </v-col>

                <!-- Authentication Header Name -->
                <v-col cols="12" sm="12" md="6">
                  <div class="d-flex align-center flex-start gap-2">
                    <label for="Authentication Header Name">{{ $t("authenticationHeaderName") }}</label>
                    <v-tooltip location="top" max-width="400px">
                      <template v-slot:activator="{ props }">
                        <img
                          v-bind="props"
                          src="@/assets/intent group toolip.svg"
                          alt="info"
                          width="18"
                          height="18"
                        />
                      </template>
                      <span>{{ $t("_tipAuthHeaderName") }}</span>
                    </v-tooltip>
                  </div>
                  <v-text-field
                    id="add-field-authen-header-modeldata"
                    v-model="AuthenHeaderName"
                    :placeholder="$t('authenticationHeaderName')"
                    variant="none"
                    density="comfortable"
                    :rules="
                      currentPlatform == 'Other'
                        ? rules.required
                        : rules.notRequired
                    "
                    :disabled="currentPlatform != 'Other'"
                    class="model-input-control mt-1"
                  >
                  </v-text-field>
                </v-col>

                <!-- API Key -->
                <v-col cols="12" sm="12" md="6">
                  <div class="d-flex align-center flex-start gap-2">
                    <label for="API Key">{{ $t("apiKey") }}</label>
                    <v-tooltip location="top" max-width="400px">
                      <template v-slot:activator="{ props }">
                        <img
                          v-bind="props"
                          src="@/assets/intent group toolip.svg"
                          alt="info"
                          width="18"
                          height="18"
                        />
                      </template>
                      <span>{{ $t("_tipApiKeySecret") }}</span>
                    </v-tooltip>
                  </div>
                  <v-text-field
                    id="add-field-APIkey-modeldata"
                    v-model="API_Key"
                    :placeholder="$t('apiKey')"
                    variant="none"
                    density="comfortable"
                    :type="Show_API_Key ? 'text' : 'password'"
                    :rules="
                      currentPlatform == 'Other'
                        ? rules.required
                        : rules.notRequired
                    "
                    class="model-input-control mt-1"
                  >
                    <template v-slot:append-inner>
                      <v-btn
                        variant="text"
                        @click="Show_API_Key = !Show_API_Key"
                      >
                        <img :src="Show_API_Key ? eyeOn : eyeOff" alt="img" width="20" height="20" />
                      </v-btn>
                    </template>
                  </v-text-field>
                </v-col>
                <v-col cols="12" sm="12" md="12" class="mt-4">
                  <hr>
                </v-col>
              </v-row>
            </div>

            <!-- Pricing Configuration -->
            <div class="form-section mt-4">
              <div class="d-flex align-center flex-start gap-2">
                <img src="@/assets/money-dollar-circle-line-red.svg" alt="img" width="20" height="20" />
                <span class="section-title">{{ $t("pricingConfiguration") }}</span>
              </div>
              <v-row class="mt-2" dense v-if="currentModelType !== 'text_to_image'">
                <v-col cols="12" sm="12" md="6">
                  <div class="d-flex align-center flex-start gap-2">
                    <label for="Input Price">{{ $t("inputPrice") }}</label>
                    <span class="text-error">*</span>
                    <v-tooltip location="top" max-width="230px">
                      <template v-slot:activator="{ props }">
                        <img
                          v-bind="props"
                          src="@/assets/intent group toolip.svg"
                          alt="info"
                          width="18"
                          height="18"
                        />
                      </template>
                      <span>{{ $t("_tipInputPricePerToken") }}</span>
                    </v-tooltip>
                  </div>
                    <v-text-field
                      id="add-field-InputPrice-modeldata"
                      v-model="CurrentPromptPrice"
                      :placeholder="$t('_pricePer1kTokens')"
                      variant="none"
                      density="comfortable"
                      type="number"
                      step="1"
                      class="model-input-control mt-1 model-number-spinner"
                      :rules="rules.requiredNumber"
                      :error-messages="errorMessage.CurrentPromptPrice.message"
                      :error="errorMessage.CurrentPromptPrice.error"
                    >
                      <template #append-inner>
                        <div class="number-arrows">
                          <v-btn
                            variant="text"
                            size="x-small"
                            @click.stop="adjustPromptPrice(1)"
                          >
                            <img src="@/assets/number-up.svg" alt="img" width="10" height="10" />
                          </v-btn>
                          <v-btn
                            variant="text"
                            size="x-small"
                            @click.stop="adjustPromptPrice(-1)"
                          >
                            <img src="@/assets/number-down.svg" alt="img" width="10" height="10" />
                          </v-btn>
                        </div>
                      </template>
                    </v-text-field>
                </v-col>

                <v-col cols="12" sm="12" md="6">
                  <div class="d-flex align-center flex-start gap-2">
                    <label for="Output Price">{{ $t("outputPrice") }}</label>
                    <span class="text-error">*</span>
                    <v-tooltip location="top" max-width="230px">
                      <template v-slot:activator="{ props }">
                        <img
                          v-bind="props"
                          src="@/assets/intent group toolip.svg"
                          alt="info"
                          width="18"
                          height="18"
                        />
                      </template>
                      <span>{{ $t("_tipOutputPricePerToken") }}</span>
                    </v-tooltip>
                  </div>
                    <v-text-field
                      id="add-field-outputprice-modeldata"
                      v-model="CurrentCompletionPrice"
                      :placeholder="$t('_pricePer1kTokens')"
                      variant="none"
                      density="comfortable"
                      type="number"
                      step="1"
                      class="model-input-control mt-1 model-number-spinner"
                      :rules="rules.requiredNumber"
                      :error-messages="errorMessage.CurrentCompletionPrice.message"
                      :error="errorMessage.CurrentCompletionPrice.error"
                    >
                      <template #append-inner>
                        <div class="number-arrows">
                          <v-btn
                            type="button"
                            variant="text"
                            size="x-small"
                            @click.stop="adjustOutputPrice(1)"
                          >
                            <img src="@/assets/number-up.svg" alt="up" width="10" height="10" />
                          </v-btn>
                          <v-btn
                            type="button"
                            variant="text"
                            size="x-small"
                            @click.stop="adjustOutputPrice(-1)"
                          >
                            <img src="@/assets/number-down.svg" alt="down" width="10" height="10" />
                          </v-btn>
                        </div>
                      </template>
                    </v-text-field>
                </v-col>
              </v-row>

              <v-row class="mt-2" v-else dense>
                <v-col cols="12" sm="12" md="12">
                  <v-text-field
                    id="add-field-ImagePrice-modeldata"
                    v-model="CurrentImagePrice"
                    :placeholder="$t('_pricePerImage')"
                    variant="none"
                    density="comfortable"
                    type="number"
                    step="1"
                    class="model-input-control mt-1 model-number-spinner"
                    :rules="rules.requiredNumber"
                  >
                    <template #append-inner>
                      <div class="number-arrows">
                        <v-btn
                          type="button"
                          variant="text"
                          size="x-small"
                          @click.stop="adjustCurrentImagePrice(1)"
                        >
                          <img src="@/assets/number-up.svg" alt="up" width="10" height="10" />
                        </v-btn>
                        <v-btn
                          type="button"
                          variant="text"
                          size="x-small"
                          @click.stop="adjustCurrentImagePrice(-1)"
                        >
                          <img src="@/assets/number-down.svg" alt="down" width="10" height="10" />
                        </v-btn>
                      </div>
                    </template>
                  </v-text-field>
                </v-col>
              </v-row>
              <div class="mt-6">
                <hr>
              </div>
            </div>

            <!-- Image Options (for text-to-image models) -->
            <transition name="fade-slide" class="mt-4">
              <div v-if="currentModelType === 'text_to_image'" class="form-section">
                <div class="d-flex align-center flex-start gap-2">
                  <img src="@/assets/Image option.svg" alt="img" width="18" height="18" />
                  <span class="section-title">{{ $t("imageGenerationOptions") }}</span>
                </div>
                <v-row class="mt-2" dense>
                  <v-col cols="12" sm="12" md="6" class="mt-2">
                    <div class="d-flex align-center flex-start gap-2">
                      <label for="Quality">{{ $t("quality") }}</label>
                      <span class="text-error">*</span>
                      <v-tooltip location="top" max-width="230px">
                        <template v-slot:activator="{ props }">
                          <img
                            v-bind="props"
                            src="@/assets/intent group toolip.svg"
                            alt="info"
                            width="18"
                            height="18"
                          />
                        </template>
                        <span>{{ $t("_tipQualityVisual") }}</span>
                      </v-tooltip>
                    </div>
                    <v-select
                      id="add-field-imageQuality-modeldata"
                      v-model="currentQuality"
                      :items="imageQualityOptions"
                      item-title="text"
                      item-value="value"
                      :placeholder="$t('quality')"
                      variant="none"
                      density="comfortable"
                      :rules="rules.required"
                      class="model-input-control mt-1"
                    >
                    </v-select>
                  </v-col>

                  <v-col cols="12" sm="12" md="6" class="mt-2">
                    <div class="d-flex align-center flex-start gap-2">
                      <label for="Resolution">{{ $t("resolution") }}</label>
                      <span class="text-error">*</span>
                      <v-tooltip location="top" max-width="360px">
                        <template v-slot:activator="{ props }">
                          <img
                            v-bind="props"
                            src="@/assets/intent group toolip.svg"
                            alt="info"
                            width="18"
                            height="18"
                          />
                        </template>
                        <span>{{ $t('_tipResolutionSizes') }}</span>
                      </v-tooltip>
                    </div>
                    <v-combobox
                      id="add-field-Resolution-modeldata"
                      v-model="currentResolution"
                      :items="['auto', '1024x1024', '1024x1536', '1536x1024', '1792x1024', '1024x1792']"
                      :placeholder="$t('resolution')"
                      variant="none"
                      density="comfortable"
                      :rules="rules.imageSize"
                      class="model-input-control mt-1"
                    >
                    </v-combobox>
                    <span class="text-caption text-medium-emphasis">
                      gpt-image: auto, 1024x1024, 1024x1536, 1536x1024 · dall-e-3: 1024x1024, 1792x1024, 1024x1792 · custom size allowed (e.g. 1536x864)
                    </span>
                  </v-col>

                  <v-col cols="12" sm="12" md="6" class="mt-2">
                    <div class="d-flex align-center flex-start gap-2">
                      <label for="ResponseFormat">{{ $t("responseFormat") }}</label>
                      <span class="text-error">*</span>
                      <v-tooltip location="top" max-width="230px">
                        <template v-slot:activator="{ props }">
                          <img
                            v-bind="props"
                            src="@/assets/intent group toolip.svg"
                            alt="info"
                            width="18"
                            height="18"
                          />
                        </template>
                        <span>{{ $t("_tipResponseFormatImage") }}</span>
                      </v-tooltip>
                    </div>
                    <v-select
                      id="add-field-imageFormat-modeldata"
                      v-model="currentResFormat"
                      :items="imageFormatOptions"
                      item-title="text"
                      item-value="value"
                      :placeholder="$t('responseFormat')"
                      variant="none"
                      density="comfortable"
                      :rules="rules.required"
                      class="model-input-control mt-1"
                    >
                    </v-select>
                  </v-col>
                </v-row>
                <div class="mt-6">
                  <hr>
                </div>
              </div>
            </transition>

            <!-- Additional Options -->
            <div class="form-section mt-6">
              <div class="d-flex align-center flex-start gap-2">
                <img src="@/assets/material-symbols_page-info.svg" alt="img" width="18" height="18" />
                <span class="section-title">{{ $t("additionalOptions") }}</span>
              </div>
              <v-row>
                <v-col cols="12" sm="12" md="6" class="mt-2">
                  <div class="additional-option-group">
                    <div class="d-flex align-center justify-start gap-2 mt-3" >
                      <p class="switch-title">{{ $t("fileUploadSupport") }}</p>
                      <v-tooltip location="top" max-width="230px">
                        <template v-slot:activator="{ props }">
                          <img
                            v-bind="props"
                            src="@/assets/intent group toolip.svg"
                            alt="info"
                            width="18"
                            height="18"
                          />
                        </template>
                        <span>{{ $t("_tipFileUploadSupport") }}</span>
                      </v-tooltip>
                    </div>
                    <div class="d-flex align-center justify-space-between">
                      <p style="color: #171717; font-size: 14px;">{{ $t("allowFileUploads") }}</p>
                      <v-switch id="add-switch-uploadfile-modeldata" v-model="UseUploadFile" class="memory-switch" hide-details></v-switch>
                    </div>
                  </div>
                </v-col>

                <v-col
                  v-if="currentModelType !== 'text_to_image'"
                  cols="12"
                  sm="12"
                  md="6"
                  class="mt-2"
                >
                  <div class="additional-option-group">
                    <div class="d-flex align-center flex-start gap-2 mt-3">
                      <p class="switch-title">{{ $t("reasoningEffort") }}</p>
                      <v-tooltip location="top" max-width="230px">
                        <template v-slot:activator="{ props }">
                          <img
                            v-bind="props"
                            src="@/assets/intent group toolip.svg"
                            alt="info"
                            width="18"
                            height="18"
                          />
                        </template>
                        <span>{{ $t("_tipReasoningEffort") }}</span>
                      </v-tooltip>
                    </div>
                    <div class="switch-item">
                      <p class="switch-description">{{ $t("enableAdvancedReasoning") }}</p>
                      <v-switch
                        id="add-switch-EnacleReasoningEffort-modeldata"
                        v-model="UseReasoningEffort"
                        class="memory-switch"
                        hide-details
                      />
                    </div>
                  </div>
                </v-col>
              </v-row>
            </div>
            <div class="mt-6">
              <hr>
            </div>

            <!-- JSON Configuration -->
            <div class="form-section mt-4">
              <div class="d-flex justify-space-between align-center">
                <div class="d-flex align-center flex-start gap-2">
                  <img src="@/assets/si_json-duotone.svg" alt="img" width="18" height="18" />
                  <span class="section-title">{{ $t("jsonConfiguration") }}</span>
                </div>
                <v-btn @click="showMoreJSONFormat = !showMoreJSONFormat" icon variant="text" size="small">
                  <v-icon :color="showMoreJSONFormat ? '#872612' : '#872612'" size="35">{{ showMoreJSONFormat ? 'mdi-menu-up' : 'mdi-menu-down' }}</v-icon>
                </v-btn>
              </div>

              <v-expand-transition>
                <div v-show="showMoreJSONFormat">
                  <div class="mt-2">
                    <h4 class="section-title">{{ $t("_systemPromptFormat") }}</h4>
                    <div class="code-example">
                        <pre><code>{{ systemPromptFormatExample }}</code></pre>
                    </div>
                    <ul class="format-notes">
                      <li style="font-size: 13px; color: #171717;">{{ $t("_noteRole") }}</li>
                      <li style="font-size: 13px; color: #171717;">{{ $t("_noteMaxCompletionTokens") }}</li>
                      <li style="font-size: 13px; color: #171717;">{{ $t("_noteStream") }}</li>
                    </ul>
                  </div>

                  <!-- JSON Editor -->
                  

                  <div v-if="jsonFormatError" class="error-message">
                    <v-icon size="16" color="error" class="mr-2">mdi-alert-circle</v-icon>
                    <span v-if="jsonFormatError.line">{{ $t("_invalidJsonLineCol", { line: jsonFormatError.line, col: jsonFormatError.col }) }}</span>
                    <span v-else>{{ $t("_invalidJsonCheckSyntax") }}</span>
                  </div>
                </div>
              </v-expand-transition>
            </div>
          </v-form>

          <div class="json-editor-container" :class="{ error: !!jsonFormatError }">
                    <prism-editor
                      v-model="JSON_Format"
                      :highlight="highlighter"
                      :line-numbers="true"
                      class="json-editor"
                      :class="{ error: !!jsonFormatError }"
                      @drop="onDrop"
                      @dragover="onDragOver"
                    />

                    <!-- JSON Tools -->
                    <div class="json-tools">
                      <button
                        type="button"
                        variant="none"
                        class="json-tool-btn"
                        :disabled="!!jsonFormatError"
                        @click="beautifyJson"
                      >
                        <v-icon size="16" style="color: #ffffff;">mdi-auto-fix</v-icon>
                        <span style="color: #ffffff; font-size: 14px;">{{ $t("beautify") }}</span>
                      </button>
                      <v-menu>
                        <template v-slot:activator="{ props }">
                          <button
                            type="button"
                            v-bind="props"
                            variant="none"
                            class="json-tool-btn"
                          >
                            <img src="@/assets/ic_round-plus.svg" alt="img" width="16" height="16" />
                            <span style="color: #ffffff; font-size: 14px;">{{ $t("addValue") }}</span>
                          </button>
                        </template>
                        <v-list class="json-menu">
                          <v-list-item
                            v-for="(item, index) in menuKeyJSON"
                            :key="index"
                            @click="insertJsonValue(item)"
                            @dragstart="onDragStart($event, item.key)"
                            draggable="true"
                            class="json-menu-item draggable-item"
                          >
                            <v-list-item-title>{{
                              item.display
                            }}</v-list-item-title>
                          </v-list-item>
                        </v-list>
                      </v-menu>
                    </div>
          </div>
          <div v-if="jsonFormatError" class="json-error-line">
            <v-icon size="14" color="error">mdi-alert-circle</v-icon>
            <span v-if="jsonFormatError.line">{{ $t("_jsonErrorLineCol", { line: jsonFormatError.line, col: jsonFormatError.col }) }}</span>
            <span v-else>{{ $t("invalidJsonFormat") }}</span>
          </div>
        </div>

        <hr>

        <!-- Dialog Actions -->
        <div class="dialog-actions">
          <button type="button" variant="none" @click="Close" class="model-cancel-button">
            <span style="color: #646464;">{{ $t("cancel") }}</span>
          </button>
          <button
            type="button"
            id="add-button-save-modeldata"
            variant="none"
            @click="AddModelData"
            :loading="dialog"
            :disabled="currentPlatform === 'Other' && !!jsonFormatError"
            class="models-add-button"
          >
            <span style="color: #ffffff; font-weight: 500;">{{ $t("add") }}</span>
          </button>
        </div>
      </v-card>
    </v-dialog>

    <!-- Model Edit Dialog -->
    <v-dialog v-model="EditdialogUser" max-width="1000px" persistent class="modern-dialog" >
      <v-card class="dialog-card">
        <div class="header-text-content">
          <h2 class="dialog-header-title"> {{ $t("editnewmodel") }} </h2>
          <p class="dialog-text">{{ $t("_editModelSubtitle") }}</p>
        </div>
        <div>
          <hr>
        </div>
        
        <!-- Dialog Content -->
        <div class="dialog-body">
          <v-form ref="editForm">
            <!-- Basic Information -->
            <div class="form-section mt-4">
              <div class="d-flex align-center flex-start gap-2">
                <img src="@/assets/streamline-block_basic-ui-link.svg" alt="img" width="18" height="18" />
                <span class="section-title">{{ $t("basicInformation") }}</span>
              </div>
              <v-row class="mt-2" dense>
                <v-col cols="12" sm="12" md="6">
                  <div class="d-flex align-center flex-start gap-2">
                    <label for="Platform">{{ $t("platform") }}</label>
                    <span class="text-error">*</span>
                    <v-tooltip location="top" max-width="400px">
                      <template v-slot:activator="{ props }">
                        <img
                          v-bind="props"
                          src="@/assets/intent group toolip.svg"
                          alt="info"
                          width="18"
                          height="18"
                        />
                      </template>
                      <span>{{ $t("_tipHostingPlatform") }}</span>
                    </v-tooltip>
                  </div>
                  <v-autocomplete
                    id="edit-field-platform-modeldata"
                    v-model="currentPlatform"
                    :items="platformOptions"
                    item-title="text"
                    item-value="value"
                    :placeholder="$t('selectPlatform')"
                    persistent-placeholder
                    variant="none"
                    density="comfortable"
                    :rules="rules.required"
                    @update:model-value="changePlatform"
                    class="model-input-control mt-1"
                    clearable
                  >
                  </v-autocomplete>
                </v-col>

                <!-- Model Provider -->
                <v-col cols="12" sm="12" md="6">
                  <div class="d-flex align-center flex-start gap-2">
                    <label for="Model Provider">{{ $t("modelProvider") }}</label>
                    <span class="text-error">*</span>
                    <v-tooltip location="top" max-width="400px">
                      <template v-slot:activator="{ props }">
                        <img
                          v-bind="props"
                          src="@/assets/intent group toolip.svg"
                          alt="info"
                          width="18"
                          height="18"
                        />
                      </template>
                      <span>{{ $t("_tipModelProviderOrg") }}</span>
                    </v-tooltip>
                  </div>
                  <v-autocomplete
                    id="edit-field-provider-modeldata"
                    v-model="currentProvider"
                    :items="filteredProviderOptions"
                    item-title="providerName"
                    item-value="providerName"
                    :placeholder="$t('selectModelProvider')"
                    persistent-placeholder
                    variant="none"
                    density="comfortable"
                    :rules="rules.required"
                    :disabled="isModelProviderAutoFilled"
                    @update:model-value="changeProvider"
                    class="model-input-control mt-1"
                    clearable
                  >
                  </v-autocomplete>
                </v-col>

                <v-col cols="12" sm="12" md="6">
                  <div class="d-flex align-center flex-start gap-2">
                    <label for="Model Type">{{ $t("modelType") }}</label>
                    <span class="text-error">*</span>
                    <v-tooltip location="top" max-width="400px">
                      <template v-slot:activator="{ props }">
                        <img
                          v-bind="props"
                          src="@/assets/intent group toolip.svg"
                          alt="info"
                          width="18"
                          height="18"
                        />
                      </template>
                      <span>{{ $t("_tipModelTypeClassification") }}</span>
                    </v-tooltip>
                  </div>
                  <v-autocomplete
                    id="edit-field-modeltye-modeldata"
                    v-model="currentModelType"
                    :items="modelTypes"
                    item-title="typeName"
                    item-value="typeValue"
                    :placeholder="$t('modelType')"
                    variant="none"
                    density="comfortable"
                    :rules="rules.required"
                    class="model-input-control mt-1"
                  >
                  </v-autocomplete>
                </v-col>
              </v-row>
            </div>

            <div class="mt-6">
              <hr>
            </div>

            <!-- Model Details -->
            <div class="form-section mt-4">
              <div class="d-flex align-center flex-start gap-2">
                <img src="@/assets/config.svg" alt="img" width="18" height="18" />
                <span class="section-title">{{ $t("modelConfiguration") }}</span>
              </div>
              <v-row class="mt-2" dense>
                <v-col cols="12" sm="12" md="6">
                  <div class="d-flex align-center flex-start gap-2">
                    <label for="Display Name">{{ $t("displayName") }}</label>
                    <span class="text-error">*</span>
                    <v-tooltip location="top" max-width="400px">
                      <template v-slot:activator="{ props }">
                        <img
                          v-bind="props"
                          src="@/assets/intent group toolip.svg"
                          alt="info"
                          width="18"
                          height="18"
                        />
                      </template>
                      <span>{{ $t("_tipDisplayNameVisible") }}</span>
                    </v-tooltip>
                  </div>
                  <v-text-field
                    id="edit-field-modeldisplay-modeldata"
                    v-model="currentModelDisplay"
                    :placeholder="$t('displayName')"
                    variant="none"
                    density="comfortable"
                    :rules="rules.required"
                    class="model-input-control mt-1"
                  >
                  </v-text-field>
                </v-col>

                <v-col cols="12" sm="12" md="6">
                  <div class="d-flex align-center flex-start gap-2">
                    <label for="Model Name">{{ $t("modelName") }}</label>
                    <span class="text-error">*</span>
                    <v-tooltip location="top" max-width="400px">
                      <template v-slot:activator="{ props }">
                        <img
                          v-bind="props"
                          src="@/assets/intent group toolip.svg"
                          alt="info"
                          width="18"
                          height="18"
                        />
                      </template>
                      <span>{{ $t("_tipModelNameTechnical") }}</span>
                    </v-tooltip>
                  </div>
                  <v-text-field
                    id="edit-field-modelname-modeldata"
                    v-model="currentModelName"
                    :placeholder="$t('modelName')"
                    variant="none"
                    density="comfortable"
                    :rules="rules.required"
                    class="model-input-control mt-1"
                  >
                  </v-text-field>
                </v-col>

                <v-col v-if="showApiVersionField" cols="12" sm="12" md="6" class="mt-2">
                  <div class="d-flex align-center flex-start gap-2">
                    <label for="API Version">{{ $t("apiVersion") }}</label>
                    <span class="text-error">*</span>
                    <v-tooltip location="top" max-width="400px">
                      <template v-slot:activator="{ props }">
                        <img
                          v-bind="props"
                          src="@/assets/intent group toolip.svg"
                          alt="info"
                          width="18"
                          height="18"
                        />
                      </template>
                      <span>{{ $t("_tipApiVersionRelease") }}</span>
                    </v-tooltip>
                  </div>
                  <v-text-field
                    id="edit-field-APIversion-modeldata"
                    v-model="currentAPIVesion"
                    :placeholder="$t('apiVersion')"
                    variant="none"
                    density="comfortable"
                    :rules="rules.required"
                    class="model-input-control mt-1"
                  >
                  </v-text-field>
                </v-col>

                <v-col cols="12" sm="12" md="6" class="mt-2">
                  <div class="d-flex align-center flex-start gap-2">
                    <label for="Max Token">{{ $t("maxToken") }}</label>
                    <span class="text-error">*</span>
                    <v-tooltip location="top" max-width="400px">
                      <template v-slot:activator="{ props }">
                        <img
                          v-bind="props"
                          src="@/assets/intent group toolip.svg"
                          alt="info"
                          width="18"
                          height="18"
                        />
                      </template>
                      <span>{{ $t("_tipMaxTokenLimit") }}</span>
                    </v-tooltip>
                  </div>
                  <v-text-field
                    id="edit-field-maxToken-modeldata"
                    v-model="maxToken"
                    :placeholder="$t('maxToken')"
                    variant="none"
                    density="comfortable"
                    class="model-input-control mt-1 model-number-spinner"
                    type="number"
                    min="0"
                    @keydown="preventNegative"
                  >
                    <template #append-inner>
                      <div class="number-arrows">
                        <v-btn
                          type="button"
                          variant="text"
                          size="x-small"
                          @click.stop="editMaxToken(1)"
                        >
                          <img src="@/assets/number-up.svg" alt="up" width="10" height="10" />
                        </v-btn>
                        <v-btn
                          type="button"
                          variant="text"
                          size="x-small"
                          @click.stop="editMaxToken(-1)"
                        >
                          <img src="@/assets/number-down.svg" alt="down" width="10" height="10" />
                        </v-btn>
                      </div>
                    </template>
                  </v-text-field>
                </v-col>
                <v-col cols="12" sm="12" md="6" class="mt-2">
                  <div class="d-flex align-center flex-start gap-2">
                    <label for="edit-field-llmTimeout-modeldata">{{ $t("timeoutResponse") }}</label>
                    <v-tooltip location="top" max-width="280px">
                      <template v-slot:activator="{ props }">
                        <img
                          v-bind="props"
                          src="@/assets/intent group toolip.svg"
                          alt="info"
                          width="18"
                          height="18"
                        />
                      </template>
                      <span>{{ $t("_tipTimeoutResponse") }}</span>
                    </v-tooltip>
                  </div>
                  <v-text-field
                    id="edit-field-llmTimeout-modeldata"
                    v-model.number="LlmTimeout"
                    :placeholder="$t('timeoutResponseSeconds')"
                    variant="outlined"
                    density="comfortable"
                    class="model-input-control mt-1"
                    type="number"
                    step="0.01"
                    min="1"
                    max="3600"
                    clearable
                    :hint="$t('_hintTimeoutResponse')"
                    persistent-hint
                    :error-messages="errorMessage.LlmTimeout.message"
                    :error="errorMessage.LlmTimeout.error"
                    @keypress="isPositiveDecimal($event)"
                    @update:model-value="clearLlmTimeoutError"
                  />
                </v-col>
              </v-row>
              <div class="mt-6">
                <hr>
              </div>

              <!-- Additional fields for Other platform -->
              <div v-if="currentPlatform === 'Other'" class="d-flex align-center flex-start gap-2 mt-4">
                <img src="@/assets/icon-park-outline_endpoint-displacement.svg" alt="img" width="18" height="18" />
                <span class="section-title">{{ $t("endpointUrl") }}</span>
              </div>
              <transition class="mt-1" name="fade-slide" dense>
                <v-row v-if="currentPlatform === 'Other'">
                  <v-col cols="12" sm="12" md="12">
                    <div class="d-flex align-center flex-start gap-2">
                      <label for="Endpoint URL">{{ $t("endpointUrl") }}</label>
                      <span class="text-error">*</span>
                      <v-tooltip location="top" max-width="400px">
                        <template v-slot:activator="{ props }">
                          <img
                            v-bind="props"
                            src="@/assets/intent group toolip.svg"
                            alt="info"
                            width="18"
                            height="18"
                          />
                        </template>
                        <span>{{ $t("_tipEndpointUrlTarget") }}</span>
                      </v-tooltip>
                    </div>
                    <v-text-field
                      id="edit-field-endpointURL-modeldata"
                      v-model="EndPointURL"
                      :placeholder="$t('endpointUrl')"
                      variant="none"
                      density="comfortable"
                      :rules="rules.required"
                      class="model-input-control mt-1"
                    >
                    </v-text-field>
                  </v-col>

                  <!-- Authentication Header Name -->
                  <v-col cols="12" sm="12" md="6">
                    <div class="d-flex align-center flex-start gap-2">
                      <label for="Authentication Header Name">{{ $t("authenticationHeaderName") }}</label>
                      <v-tooltip location="top" max-width="400px">
                        <template v-slot:activator="{ props }">
                          <img
                            v-bind="props"
                            src="@/assets/intent group toolip.svg"
                            alt="info"
                            width="18"
                            height="18"
                          />
                        </template>
                        <span>{{ $t("_tipAuthHeaderName") }}</span>
                      </v-tooltip>
                    </div>
                    <v-text-field
                      id="edit-field-authen-header-modeldata"
                      v-model="AuthenHeaderName"
                      :placeholder="$t('authenticationHeaderName')"
                      variant="none"
                      density="comfortable"
                      :rules="
                        currentPlatform == 'Other'
                          ? rules.required
                          : rules.notRequired
                      "
                      :disabled="currentPlatform != 'Other'"
                      class="model-input-control mt-1"
                    >
                    </v-text-field>
                  </v-col>

                    <!-- API Key -->
                  <v-col cols="12" sm="12" md="6">
                    <div class="d-flex align-center flex-start gap-2">
                      <label for="API Key">{{ $t("apiKey") }}</label>
                      <v-tooltip location="top" max-width="400px">
                        <template v-slot:activator="{ props }">
                          <img
                            v-bind="props"
                            src="@/assets/intent group toolip.svg"
                            alt="info"
                            width="18"
                            height="18"
                          />
                        </template>
                        <span>{{ $t("_tipApiKeySecret") }}</span>
                      </v-tooltip>
                    </div>
                    <v-text-field
                      id="edit-field-APIkey-modeldata"
                      v-model="API_Key"
                      :placeholder="$t('apiKey')"
                      variant="none"
                      density="comfortable"
                      :type="Show_API_Key ? 'text' : 'password'"
                      :rules="
                        currentPlatform == 'Other'
                          ? rules.required
                          : rules.notRequired
                      "
                      class="model-input-control mt-1"
                    >
                      <template v-slot:append-inner>
                        <v-btn
                          icon
                          variant="text"
                          size="small"
                          @click="Show_API_Key = !Show_API_Key"
                        >
                          <img :src="Show_API_Key ? eyeOn : eyeOff" alt="img" width="20" height="20" />
                        </v-btn>
                      </template>
                    </v-text-field>
                  </v-col>
                  <v-col cols="12" sm="12" md="12" class="mt-4">
                    <hr>
                  </v-col>
                </v-row>
              </transition>
            </div>

            <!-- Pricing Configuration -->
            <div class="form-section mt-4">
              <div class="d-flex align-center flex-start gap-2">
                <img src="@/assets/money-dollar-circle-line-red.svg" alt="img" width="20" height="20" />
                <span class="section-title">{{ $t("pricingConfiguration") }}</span>
              </div>
              <v-row class="mt-2" v-if="currentModelType !== 'text_to_image'" dense>
                <v-col cols="12" sm="12" md="6">
                  <div class="d-flex align-center flex-start gap-2">
                    <label for="Input Price">{{ $t("inputPrice") }}</label>
                    <span class="text-error">*</span>
                    <v-tooltip location="top" max-width="230px">
                      <template v-slot:activator="{ props }">
                        <img
                          v-bind="props"
                          src="@/assets/intent group toolip.svg"
                          alt="info"
                          width="18"
                          height="18"
                        />
                      </template>
                      <span>{{ $t("_tipInputPricePerToken") }}</span>
                    </v-tooltip>
                  </div>
                  <v-text-field
                    id="edit-field-inputprice-modeldata"
                    v-model="CurrentPromptPrice"
                    :placeholder="$t('inputPriceUsd')"
                    variant="none"
                    density="comfortable"
                    type="number"
                    step="1"
                    class="model-input-control mt-1 model-number-spinner"
                    :rules="rules.requiredNumber"
                    :error-messages="errorMessage.CurrentPromptPrice.message"
                    :error="errorMessage.CurrentPromptPrice.error"
                  >
                    <template #append-inner>
                      <div class="number-arrows">
                        <v-btn
                          type="button"
                          variant="text"
                          size="x-small"
                          @click.stop="editInputPrice(1)"
                        >
                          <img src="@/assets/number-up.svg" alt="up" width="10" height="10" />
                        </v-btn>
                        <v-btn
                          type="button"
                          variant="text"
                          size="x-small"
                          @click.stop="editInputPrice(-1)"
                        >
                          <img src="@/assets/number-down.svg" alt="down" width="10" height="10" />
                        </v-btn>
                      </div>
                    </template>
                  </v-text-field>
                </v-col>

                <v-col cols="12" sm="12" md="6">
                  <div class="d-flex align-center flex-start gap-2">
                    <label for="Output Price">{{ $t("outputPrice") }}</label>
                    <span class="text-error">*</span>
                    <v-tooltip location="top" max-width="400px">
                      <template v-slot:activator="{ props }">
                        <img
                          v-bind="props"
                          src="@/assets/intent group toolip.svg"
                          alt="info"
                          width="18"
                          height="18"
                        />
                      </template>
                      <span>{{ $t("_tipOutputPricePerToken") }}</span>
                    </v-tooltip>
                  </div>
                  <v-text-field
                    id="edit-field-outputprice-modeldata"
                    v-model="CurrentCompletionPrice"
                    :placeholder="$t('outputPriceUsd')"
                    variant="none"
                    density="comfortable"
                    type="number"
                    step="1"
                    class="model-input-control mt-1 model-number-spinner"
                    :rules="rules.requiredNumber"
                    :error-messages="errorMessage.CurrentCompletionPrice.message" 
                    :error="errorMessage.CurrentCompletionPrice.error"
                  >
                    <template #append-inner>
                      <div class="number-arrows">
                        <v-btn
                          type="button"
                          variant="text"
                          size="x-small"
                          @click.stop="editOutputPrice(1)"
                        >
                          <img src="@/assets/number-up.svg" alt="up" width="10" height="10" />
                        </v-btn>
                        <v-btn
                          type="button"
                          variant="text"
                          size="x-small"
                          @click.stop="editOutputPrice(-1)"
                        >
                          <img src="@/assets/number-down.svg" alt="down" width="10" height="10" />
                        </v-btn>
                      </div>
                    </template>
                  </v-text-field>
                </v-col>
              </v-row>

              <v-row class="mt-2" v-else dense>
                <v-col cols="12" sm="12" md="12">
                  <div class="d-flex align-center flex-start gap-2">
                    <label for="Input Price">{{ $t("inputPrice") }}</label>
                    <span class="text-error">*</span>
                    <v-tooltip location="top" max-width="400px">
                      <template v-slot:activator="{ props }">
                        <img
                          v-bind="props"
                          src="@/assets/intent group toolip.svg"
                          alt="info"
                          width="18"
                          height="18"
                        />
                      </template>
                      <span>{{ $t("_tipInputPricePerToken") }}</span>
                    </v-tooltip>
                  </div>
                  <v-text-field
                    id="edit-field-Imageprice-modeldata"
                    v-model="CurrentImagePrice"
                    :placeholder="$t('imagePriceUsd')"
                    variant="none"
                    density="comfortable"
                    type="number"
                    step="1"
                    class="model-input-control mt-1 model-number-spinner"
                    :rules="rules.requiredNumber"
                  >
                    <template #append-inner>
                      <div class="number-arrows">
                        <v-btn
                          type="button"
                          variant="text"
                          size="x-small"
                          @click.stop="editCurrentImagePrice(1)"
                        >
                          <img src="@/assets/number-up.svg" alt="up" width="10" height="10" />
                        </v-btn>
                        <v-btn
                          type="button"
                          variant="text"
                          size="x-small"
                          @click.stop="editCurrentImagePrice(-1)"
                        >
                          <img src="@/assets/number-down.svg" alt="down" width="10" height="10" />
                        </v-btn>
                      </div>
                    </template>
                  </v-text-field>
                </v-col>
              </v-row>
              <div class="mt-6">
                <hr>
              </div>
            </div>


            <!-- Image Options -->
            <transition name="fade-slide" class="mt-6">
              <div v-if="currentModelType === 'text_to_image'" class="form-section">
                <div class="d-flex align-center flex-start gap-2">
                  <img src="@/assets/Image option.svg" alt="img" width="18" height="18" />
                  <span class="section-title">{{ $t("imageGenerationOptions") }}</span>
                </div>
                <v-row class="mt-2" dense>
                  <v-col cols="12" sm="12" md="6">
                    <div class="d-flex align-center flex-start gap-2">
                    <label for="Quality">{{ $t("quality") }}</label>
                    <span class="text-error">*</span>
                    <v-tooltip location="top" max-width="400px">
                      <template v-slot:activator="{ props }">
                        <img
                          v-bind="props"
                          src="@/assets/intent group toolip.svg"
                          alt="info"
                          width="18"
                          height="18"
                        />
                      </template>
                      <span>{{ $t("_tipQualityVisual") }}</span>
                    </v-tooltip>
                  </div>
                    <v-select
                      id="edit-field-Imagequality-modeldata"
                      v-model="currentQuality"
                      :items="imageQualityOptions"
                      item-title="text"
                      item-value="value"
                      placeholderdf="Quality"
                      variant="none"
                      density="comfortable"
                      class="model-input-control mt-1"
                      :rules="rules.required"
                    >
                    </v-select>
                  </v-col>

                  <v-col cols="12" sm="12" md="6">
                    <div class="d-flex align-center flex-start gap-2">
                    <label for="Resolution">{{ $t("resolution") }}</label>
                    <span class="text-error">*</span>
                    <v-tooltip location="top" max-width="400px">
                      <template v-slot:activator="{ props }">
                        <img
                          v-bind="props"
                          src="@/assets/intent group toolip.svg"
                          alt="info"
                          width="18"
                          height="18"
                        />
                      </template>
                      <span>{{ $t('_tipResolutionSizes') }}</span>
                    </v-tooltip>
                  </div>
                    <v-combobox
                      id="edit-field-Resolution-modeldata"
                      v-model="currentResolution"
                      :items="['auto', '1024x1024', '1024x1536', '1536x1024', '1792x1024', '1024x1792']"
                      :placeholder="$t('resolution')"
                      variant="none"
                      density="comfortable"
                      class="model-input-control mt-1"
                      :rules="rules.imageSize"
                    >
                    </v-combobox>
                    <span class="text-caption text-medium-emphasis">
                      gpt-image: auto, 1024x1024, 1024x1536, 1536x1024 · dall-e-3: 1024x1024, 1792x1024, 1024x1792 · custom size allowed (e.g. 1536x864)
                    </span>
                  </v-col>

                  <v-col cols="12" sm="12" md="6" class="mt-2">
                    <div class="d-flex align-center flex-start gap-2">
                      <label for="ResponseFormat">{{ $t("responseFormat") }}</label>
                      <span class="text-error">*</span>
                      <v-tooltip location="top" max-width="230px">
                        <template v-slot:activator="{ props }">
                          <img
                            v-bind="props"
                            src="@/assets/intent group toolip.svg"
                            alt="info"
                            width="18"
                            height="18"
                          />
                        </template>
                        <span>{{ $t("_tipResponseFormatImage") }}</span>
                      </v-tooltip>
                    </div>
                    <v-select
                      id="edit-field-imageFormat-modeldata"
                      v-model="currentResFormat"
                      :items="imageFormatOptions"
                      item-title="text"
                      item-value="value"
                      :placeholder="$t('responseFormat')"
                      variant="none"
                      density="comfortable"
                      :rules="rules.required"
                      class="model-input-control mt-1"
                    >
                    </v-select>
                  </v-col>
                </v-row>
                <div class="mt-6">
                  <hr>
                </div>
              </div>
            </transition>


            <!-- Additional Options -->
            <div class="form-section mt-6">
              <div class="d-flex align-center flex-start gap-2">
                <img src="@/assets/material-symbols_page-info.svg" alt="img" width="18" height="18" />
                <span class="section-title">{{ $t("additionalOptions") }}</span>
              </div>
              <v-row>
                <v-col cols="12" sm="12" md="6" class="mt-2">
                  <div class="additional-option-group">
                    <div class="d-flex align-center justify-start gap-2 mt-3" >
                      <p class="switch-title">{{ $t("fileUploadSupport") }}</p>
                      <v-tooltip location="top" max-width="230px">
                        <template v-slot:activator="{ props }">
                          <img
                            v-bind="props"
                            src="@/assets/intent group toolip.svg"
                            alt="info"
                            width="18"
                            height="18"
                          />
                        </template>
                        <span>{{ $t("_tipFileUploadSupport") }}</span>
                      </v-tooltip>
                    </div>
                    <div class="d-flex align-center justify-space-between">
                      <p style="color: #171717; font-size: 14px;">{{ $t("allowFileUploads") }}</p>
                      <v-switch id="edit-switch-uploadfile-modeldata" v-model="UseUploadFile" class="memory-switch" hide-details></v-switch>
                    </div>
                  </div>
                </v-col>

                <v-col
                  v-if="currentModelType !== 'text_to_image'"
                  cols="12"
                  sm="12"
                  md="6"
                  class="mt-2"
                >
                  <div class="additional-option-group">
                    <div class="d-flex align-center flex-start gap-2 mt-3">
                      <p class="switch-title">{{ $t("reasoningEffort") }}</p>
                      <v-tooltip location="top" max-width="230px">
                        <template v-slot:activator="{ props }">
                          <img
                            v-bind="props"
                            src="@/assets/intent group toolip.svg"
                            alt="info"
                            width="18"
                            height="18"
                          />
                        </template>
                        <span>{{ $t("_tipReasoningEffort") }}</span>
                      </v-tooltip>
                    </div>
                    <div class="switch-item">
                      <p class="switch-description">{{ $t("enableAdvancedReasoning") }}</p>
                      <v-switch id="edit-switch-EnableReasoningEffort-modeldata" v-model="UseReasoningEffort" class="memory-switch" hide-details></v-switch>
                    </div>
                  </div>
                </v-col>
              </v-row>
            </div>

            <div class="mt-6">
              <hr>
            </div>

            <!-- JSON Configuration -->
            <div class="form-section mt-6">
              <div class="d-flex justify-space-between align-center">
                <div class="d-flex align-center flex-start gap-2">
                  <img src="@/assets/si_json-duotone.svg" alt="img" width="18" height="18" />
                  <span class="section-title">{{ $t("jsonConfiguration") }}</span>
                </div>
                <v-btn @click="showMoreJSONFormat = !showMoreJSONFormat" icon variant="text" size="small">
                  <v-icon :color="showMoreJSONFormat ? '#872612' : '#872612'" size="35">{{ showMoreJSONFormat ? 'mdi-menu-up' : 'mdi-menu-down' }}</v-icon>
                </v-btn>
              </div>

              <v-expand-transition>
                <div v-show="showMoreJSONFormat">
                  <div class="mt-2">
                    <h4 class="section-title">{{ $t("_systemPromptFormat") }}</h4>
                    <div class="code-example">
                      <pre><code>{{ systemPromptFormatExample }}</code></pre>
                    </div>
                    <ul class="format-notes">
                      <li style="font-size: 13px; color: #171717;">
                        {{ $t("_noteRole") }}
                      </li>
                      <li style="font-size: 13px; color: #171717;">
                        {{ $t("_noteMaxCompletionTokens") }}
                      </li>
                      <li style="font-size: 13px; color: #171717;">
                        {{ $t("_noteStream") }}
                      </li>
                    </ul>
                  </div>

                  <div v-if="jsonFormatError" class="error-message">
                    <v-icon size="16" color="error" class="mr-2">mdi-alert-circle</v-icon>
                    <span v-if="jsonFormatError.line">{{ $t("_invalidJsonLineCol", { line: jsonFormatError.line, col: jsonFormatError.col }) }}</span>
                    <span v-else>{{ $t("_invalidJsonCheckSyntax") }}</span>
                  </div>
                </div>
              </v-expand-transition>
            </div>

            <div class="json-editor-container" :class="{ error: !!jsonFormatError }">
              <prism-editor
                id="fleid-jsonFormat-modeldata"
                v-model="JSON_Format"
                :highlight="highlighter"
                :line-numbers="true"
                class="json-editor"
                :class="{ error: !!jsonFormatError }"
                @drop="onDrop"
                @dragover="onDragOver"
               />

                 <!-- JSON Tools -->
                 <div class="json-tools">
                   <button
                     type="button"
                     variant="none"
                     class="json-tool-btn"
                     :disabled="!!jsonFormatError"
                     @click="beautifyJson"
                   >
                     <v-icon size="16" style="color: #ffffff;">mdi-auto-fix</v-icon>
                     <span style="color: #ffffff; font-size: 14px;">{{ $t("beautify") }}</span>
                   </button>
                   <v-menu>
                     <template v-slot:activator="{ props }">
                       <button
                         type="button"
                         v-bind="props"
                         variant="none"
                         class="json-tool-btn"
                       >
                        <img src="@/assets/ic_round-plus.svg" alt="img" width="16" height="16" />
                        <span style="color: #ffffff; font-size: 14px;">{{ $t("addValue") }}</span>
                     </button>
                     </template>
                     <v-list class="json-menu">
                       <v-list-item
                         v-for="(item, index) in menuKeyJSON"
                         :key="index"
                         @click="insertJsonValue(item)"
                         @dragstart="onDragStart($event, item.key)"
                         draggable="true"
                         class="json-menu-item draggable-item"
                       >
                         <v-list-item-title>{{
                           item.display
                         }}</v-list-item-title>
                       </v-list-item>
                     </v-list>
                   </v-menu>
                 </div>
              </div>
              <div v-if="jsonFormatError" class="json-error-line">
                <v-icon size="14" color="error">mdi-alert-circle</v-icon>
                <span v-if="jsonFormatError.line">{{ $t("_jsonErrorLineCol", { line: jsonFormatError.line, col: jsonFormatError.col }) }}</span>
                <span v-else>{{ $t("invalidJsonFormat") }}</span>
              </div>
          </v-form>
        </div>

        <hr>

        <!-- Dialog Actions -->
        <div class="dialog-actions">
          <button type="button" variant="none" @click="Close" class="model-cancel-button">
            <span style="color: #646464;">{{ $t("cancel") }}</span>
          </button>
          <button
            type="button"
            id="edit-button-save-modeldata"
            variant="none"
            @click="UpdateModelData"
            :loading="dialog"
            :disabled="currentPlatform === 'Other' && !!jsonFormatError"
            class="models-add-button"
          >
            <img src="@/assets/mage_save-btn.svg" alt="img" width="20" height="20" />
            <span style="color: #ffffff; font-weight: 400;">{{ $t("save") }}</span>
          </button>
        </div>
      </v-card>
    </v-dialog>

    <!-- Warning Dialog -->
    <v-dialog v-model="showNameRequiredDialog" max-width="460" persistent>
      <v-card class="required-name-dialog" elevation="0">
        <div class="required-name-header">
          <h3 class="required-name-title">{{ $t("incompleteInformation") }}</h3>
          <button type="button" @click="clearRequiredWarning" class="close-btn">
            <img src="@/assets/codex_cross.svg" alt="close" width="24" height="24" style="margin-left: 12px;" />
          </button>
        </div>
        <div class="required-body">
          <p class="required-name-message">{{ $t("_someRequiredInfo") }}</p>
          <ul v-if="requiredMissingFields.length" class="required-field-list">
            <li v-for="field in requiredMissingFields" :key="field">{{ field }}</li>
          </ul>
        </div>
        <div>
          <hr style="border: none; border-top: 1px solid #c9c9c9;" />
        </div>
        <div class="required-footer">
          <button type="button" class="ok-required-btn" @click="clearRequiredWarning" :id="'button-requiredname-ok'">{{ $t("ok") }}</button>
        </div>
      </v-card>
    </v-dialog>

    <!-- Delete Dialog -->
    <v-dialog v-model="showDeleteDialog" max-width="570" class="delete-dialog-group">
      <v-card class="delete-dialog-card">
        <v-card-title class="card-dialog-title" style="background-color: #FFF2F2;">
          <span class="dialog-title">{{ $t("deleteConfirmation") }}</span>
          <v-btn icon variant="text" density="comfortable" @click="closeDeleteDialog">
            <img src="@/assets/Vector.svg" alt="icon" width="12" height="12">
          </v-btn>
        </v-card-title>
        <v-divider></v-divider>
        <v-card-text class="pt-6 pb-4 px-4 body-text">
          {{ $t("_confirmDeleteModelText") }}
        </v-card-text>
        <hr style="border: none; border-top: 1px solid #c9c9c9;" />
        <v-card-actions class="mt-2 mb-2 justify-end">
          <v-btn class="delete-confirm-btn" :loading="deleting" @click="Delete()">
            <img src="@/assets/heroicons_trash-solid.svg" alt="img" width="17" height="22" class="mr-2">
            <p style="color: #ffffff; font-size: 14px; font-weight: 500;">{{ $t("delete") }}</p>
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <!-- Replace Before Delete Dialog -->
    <v-dialog v-model="showReplaceDialog" max-width="560" class="delete-dialog-group" persistent>
      <v-card class="delete-dialog-card">
        <!-- Header -->
        <v-card-title class="card-dialog-title" style="background-color: #FFF8E1; min-height: 52px;">
          <div style="display: flex; align-items: center; gap: 8px;">
            <v-icon color="#E65100" size="20">mdi-alert-circle-outline</v-icon>
            <span style="font-size: 15px; font-weight: 600; color: #E65100;">{{ $t("_modelInUseReplace") }}</span>
          </div>
          <div style="display: flex; align-items: center; gap: 8px;">
            <v-chip size="x-small" color="orange" variant="tonal" style="font-size: 11px; font-weight: 600; pointer-events: none;">
              {{ $t("stepOfTwo", { step: showReplacePreview ? 2 : 1 }) }}
            </v-chip>
            <v-btn icon variant="text" density="comfortable" @click="closeDeleteDialog" :disabled="deleting">
              <img src="@/assets/Vector.svg" alt="icon" width="12" height="12">
            </v-btn>
          </div>
        </v-card-title>
        <v-divider></v-divider>

        <!-- Step 1: Select replacement -->
        <template v-if="!showReplacePreview">
          <v-card-text class="pt-4 pb-3 px-4">
            <p class="body-text mb-3">
              {{ $t("_botConfigsUsingPre") }} <strong>{{ currentModelName }}</strong>. {{ $t("_botConfigsUsingPost") }}
            </p>
            <!-- Bot list -->
            <div style="border: 1px solid #FFE0B2; border-radius: 8px; max-height: 160px; overflow-y: auto; background: #FFFDE7; margin-bottom: 16px;">
              <div
                v-for="(bot, idx) in modelInUseBots"
                :key="bot.modelID"
                :style="{
                  display: 'flex',
                  alignItems: 'center',
                  gap: '8px',
                  padding: '7px 12px',
                  borderBottom: idx < modelInUseBots.length - 1 ? '1px solid #FFE0B2' : 'none'
                }"
              >
                <v-icon size="15" color="orange-darken-2">mdi-robot</v-icon>
                <span style="font-size: 13px; color: #333;">{{ bot.modelName }}</span>
              </div>
            </div>
            <!-- Replacement select -->
            <v-select
              v-model="replacementModelId"
              :items="allDDLModels"
              item-title="modelDisplay"
              item-value="id"
              :label="$t('selectReplacementModel')"
              variant="outlined"
              density="compact"
              :no-data-text="$t('_noCompatibleModels')"
              hide-details
              class="model-input-control"
            >
              <template v-slot:item="{ props, item }">
                <v-list-item v-bind="props">
                  <template v-slot:append>
                    <span style="font-size: 11px; color: #888;">{{ item.raw?.modelName }}</span>
                  </template>
                </v-list-item>
              </template>
            </v-select>
          </v-card-text>
          <hr style="border: none; border-top: 1px solid #eee;" />
          <v-card-actions class="pa-3 justify-end" style="gap: 8px;">
            <v-btn variant="text" @click="closeDeleteDialog" :disabled="deleting" style="font-size: 14px; color: #666;">
              {{ $t("cancel") }}
            </v-btn>
            <v-btn
              :disabled="!replacementModelId"
              @click="showReplacePreview = true"
              variant="outlined"
              style="border-radius: 10px; font-size: 14px; font-weight: 500; min-width: 150px; color: #E65100; border-color: #E65100;"
            >
              {{ $t("previewChanges") }}
              <v-icon size="16" class="ml-1">mdi-arrow-right</v-icon>
            </v-btn>
          </v-card-actions>
        </template>

        <!-- Step 2: Preview -->
        <template v-else>
          <v-card-text class="pt-4 pb-3 px-4">
            <p class="body-text mb-3" style="color: #555;">{{ $t("_reviewChanges") }}</p>
            <!-- From → To visualization -->
            <div style="background: #F9F9F9; border: 1px solid #E0E0E0; border-radius: 10px; padding: 14px 14px 12px; margin-bottom: 12px;">
              <div style="display: flex; align-items: stretch; gap: 8px; margin-bottom: 12px;">
                <div style="flex: 1; background: #FFEBEE; border: 1px solid #FFCDD2; border-radius: 8px; padding: 8px 12px;">
                  <div style="font-size: 10px; color: #B71C1C; font-weight: 700; text-transform: uppercase; letter-spacing: 0.6px; margin-bottom: 4px;">{{ $t("remove") }}</div>
                  <div style="font-size: 13px; font-weight: 600; color: #333; word-break: break-all;">{{ currentModelName }}</div>
                </div>
                <div style="display: flex; align-items: center;">
                  <v-icon color="#9E9E9E" size="22">mdi-arrow-right-bold</v-icon>
                </div>
                <div style="flex: 1; background: #E8F5E9; border: 1px solid #C8E6C9; border-radius: 8px; padding: 8px 12px;">
                  <div style="font-size: 10px; color: #1B5E20; font-weight: 700; text-transform: uppercase; letter-spacing: 0.6px; margin-bottom: 4px;">{{ $t("replaceWith") }}</div>
                  <div style="font-size: 13px; font-weight: 600; color: #333; word-break: break-all;">
                    {{ allDDLModels.find(m => m.id === replacementModelId)?.modelDisplay || '' }}
                  </div>
                  <div style="font-size: 11px; color: #888; margin-top: 2px; font-family: monospace;">
                    {{ allDDLModels.find(m => m.id === replacementModelId)?.modelName || '' }}
                  </div>
                </div>
              </div>
              <!-- Affected bots chips -->
              <div style="font-size: 12px; color: #666; font-weight: 600; margin-bottom: 6px;">
                {{ $t("_affectedBotConfigs", { count: modelInUseBots.length }) }}
              </div>
              <div style="max-height: 90px; overflow-y: auto; display: flex; flex-wrap: wrap; gap: 4px;">
                <v-chip
                  v-for="bot in modelInUseBots"
                  :key="bot.modelID"
                  size="x-small"
                  variant="tonal"
                  color="orange-darken-2"
                  prepend-icon="mdi-robot"
                  style="font-size: 11px;"
                >
                  {{ bot.modelName }}
                </v-chip>
              </div>
            </div>
            <!-- Warning alert -->
            <v-alert
              type="error"
              variant="tonal"
              density="compact"
              icon="mdi-alert-circle-outline"
              style="font-size: 12px; border-radius: 8px;"
            >
              {{ $t("_replaceDeleteWarning") }}
            </v-alert>
          </v-card-text>
          <hr style="border: none; border-top: 1px solid #eee;" />
          <v-card-actions class="pa-3 justify-end" style="gap: 8px;">
            <v-btn variant="text" @click="showReplacePreview = false" :disabled="deleting" style="font-size: 14px; color: #666;">
              {{ $t("back") }}
            </v-btn>
            <v-btn
              class="delete-confirm-btn"
              style="width: auto; min-width: 210px; padding: 0 16px;"
              :loading="deleting"
              @click="ReplaceAndDelete()"
            >
              <img src="@/assets/heroicons_trash-solid.svg" alt="img" width="15" height="15" class="mr-2">
              <p style="color: #ffffff; font-size: 14px; font-weight: 500;">{{ $t("_confirmReplaceDelete") }}</p>
            </v-btn>
          </v-card-actions>
        </template>
      </v-card>
    </v-dialog>

    <!-- Action Not Allowed Fallback Dialog -->
    <v-dialog v-model="showUseModelDeleteDialog" max-width="570" class="delete-dialog-group">
      <v-card class="delete-dialog-card">
        <v-card-title class="card-dialog-title" style="background-color: #FFF2F2;">
          <span class="dialog-title">{{ $t("actionNotAllowed") }}</span>
          <v-btn icon variant="text" density="comfortable" @click="closeDeleteDialog">
            <img src="@/assets/Vector.svg" alt="icon" width="12" height="12">
          </v-btn>
        </v-card-title>
        <v-divider></v-divider>
        <v-card-text class="pt-6 pb-4 px-4 body-text">
          {{ useModelDeleteMessage || $t('_modelInUseRemoveDeps') }}
        </v-card-text>
        <hr style="border: none; border-top: 1px solid #c9c9c9;" />
        <v-card-actions class="mt-2 mb-2 justify-end">
          <v-btn class="delete-confirm-btn" :loading="deleting" @click="closeDeleteDialog()">
            <p style="color: #ffffff; font-size: 14px; font-weight: 500;">{{ $t("ok") }}</p>
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <!-- Loading Overlay -->
    <v-dialog v-model="dialog" persistent width="320">
      <v-card class="loading-card">
        <v-card-text class="text-center py-6">
          <v-progress-circular
            indeterminate
            color="primary"
            size="48"
            class="mb-4"
          ></v-progress-circular>
          <div class="loading-text">{{ $t("_Loading") }}</div>
        </v-card-text>
      </v-card>
    </v-dialog>
  </div>
</template>
<script>
import LogTrace from "@/api/function.js";

import { PrismEditor } from "vue-prism-editor";
import "vue-prism-editor/dist/prismeditor.min.css";
import { highlight, languages } from "prismjs/components/prism-core";
import "prismjs/components/prism-clike";
import "prismjs/components/prism-javascript";
import "prismjs/themes/prism-tomorrow.css";
import editImg from "@/assets/edit1.png";
import deleteImg from "@/assets/delete1.png";
import textModelTypeIcon from "@/assets/fi-rr-text.svg";
import imageModelTypeIcon from "@/assets/fi-rr-picture.svg";
import eyeOff from "@/assets/iconamoon_eye-off.svg";
import eyeOn from "@/assets/simple-line-icons_eye.svg";

export default {
  name: "MasterData",
  inject: ["flagNav","FontColorTitle","SubNavbarBackGround"],
  components: {
    PrismEditor,
  },
  mixins: [LogTrace],
  data() {
    return {
      showNameRequiredDialog: false,
      requiredMissingFields: [],
      searchKeyword: "",
      isSearch: false,
      eyeOff,
      eyeOn,
      textModelTypeIcon,
      imageModelTypeIcon,
      showSuccess: false,
      successMessage: "",
      deleting: false,
      _toastTimer: null,
      itemToDelete: null,
      showDeleteDialog: false,
      showUseModelDeleteDialog: false,
      useModelDeleteMessage: "",
      showReplaceDialog: false,
      modelInUseBots: [],
      replacementModelId: null,
      showReplacePreview: false,
      allDDLModels: [],
      isDragOver: false,
      dragCounter: 0,
      listDataModel: [],
      imageFormatOptions: [
        { text: "URL", value: "url" },
        { text: "Base64 JSON", value: "b64_json" },
      ],
      today: null,
      dialog: false,
      options: {
        page: 1,
        itemsPerPage: 10,
        sortBy: [],
        sortDesc: [],
      },
      searchTotalTable: 0,
      totalTable: 0,
      itemsPerPage: 10,
      isFirst: true,
      menus: [],
      rules: {
        notRequired: [],
        required: [(value) => !!value || "Required."],
        requiredNumber: [
          (value) => value != 0 || "Required.",
          (value) => !Number.isNaN(Number(value)) || "Must be a number.",
        ],
        // Format-only check for image size: "auto" or WIDTHxHEIGHT (e.g. 1024x1024).
        // Does not validate whether the model supports the size — that is provider-specific.
        imageSize: [
          (value) => !!value || "Required.",
          (value) =>
            /^(auto|\d+x\d+)$/.test(value || "") ||
            "Invalid size. Use 'auto' or WIDTHxHEIGHT (e.g. 1024x1024).",
        ],
      },
      errorMessage: {
        CurrentPromptPrice: {
          error: false,
          message: ''
        },
        CurrentCompletionPrice: {
          error: false,
          message: ''
        },
        LlmTimeout: {
          error: false,
          message: ''
        },
        
      },
      images: {
        edit: editImg,
        delete: deleteImg,
      },
      EditdialogUser: false,
      AdddialogUser: false,
      currentModelName: "",
      currentAPIVesion: "",
      maxToken: "",
      LlmTimeout: null,
      currentID: null,
      statusDialog: false,
      statusText: "",
      typeConfirm: "success",
      CurrentPromptPrice: 0,
      CurrentCompletionPrice: 0,
      UseUploadFile: false,
      UseReasoningEffort: false,
      currentModelDisplay: "",
      currentProvider: null,
      currentPlatform: null,
      promptPriceTHB: 0,
      completionPriceTHB: 0,
      sortBy: [],
      sortDesc: [],
      DDProvider: [],
      platformOptions: [
        { text: 'Azure', value: 'Azure' },
        // { text: 'AWS Bedrock', value: 'AWS Bedrock' },
        { text: 'Google Vertex AI', value: 'Google' },
        // { text: 'Grok API (xAI)', value: 'Grok API (xAI)' },
        { text: 'Anthropic Direct', value: 'Anthropic' },
        // { text: 'OpenAI Direct', value: 'OpenAI' },
        // { text: 'Together AI', value: 'Together AI' },
        // { text: 'Fireworks AI', value: 'Fireworks AI' },
        // { text: 'DeepInfra', value: 'DeepInfra' },
        { text: 'Other', value: 'Other' },
      ],
      platformToProviderMap: {
        // 'Grok API (xAI)': 'xAI (Grok)',
        'Anthropic': 'Anthropic',
        // 'OpenAI': 'OpenAI',
        'Google': 'Google',
      },
      currentModelType: null,
      modelTypes: [
        { typeName: "Text-Based", typeId: "1", typeValue: "text_based" },
        { typeName: "Text-to-Image", typeId: "2", typeValue: "text_to_image" },
      ],
      // New data properties for Text-to-image models
      CurrentImagePrice: 0,
      currentQuality: "", // Options: "HD" or "Standard"
      currentResolution: "", // Options: "1024x1024", "1792x1024", "1024x1792"
      currentResFormat: "", // Options: "url" or "b64_json"
      JSON_Format: "",
      systemPromptFormatExample:`{
  "messages":"{messages}"
  "role":"developer"
},
{
  "max_completion_tokens":"{max_completion_tokens}"
  "stream":"{stream}"
}`,
      lineNumbers: true,
      menuKeyJSON: [],
      JSONFormatAddStatus: false,
      JSONFormatEditStatus: false,
      showMoreJSONFormat: false,
      EndPointURL: null,
      API_Key: null,
      AuthenHeaderName: null,
      Show_API_Key: false,
    };
  },
  computed: {
    headers() {
      return [
        { title: this.$t("id"), align: "left", sortable: false, width: "60px" },
        {
          title: this.$t("platform"),
          align: "left",
          sortable: true,
          value: "platform",
          width: "120px",
        },
        {
          title: this.$t("Provider"),
          align: "left",
          sortable: true,
          value: "provider",
          width: "120px",
        },
        {
          title: this.$t("displayName"),
          align: "left",
          sortable: true,
          value: "modelDisplay",
          width: "auto",
        },
        {
          title: this.$t("modelName"),
          align: "left",
          sortable: true,
          value: "modelName",
          width: "auto",
        },
        {
          title: this.$t("apiVersion"),
          align: "left",
          sortable: true,
          value: "apiVersion",
          width: "120px",
        },
        {
          title: this.$t("modelType"),
          align: "center",
          sortable: true,
          value: "modelType",
          width: "150px",
        },
        {
          title: this.$t("price"),
          align: "center",
          sortable: false,
          value: "price",
          width: "120px",
        },
        {
          title: this.$t("actions"),
          align: "center",
          sortable: false,
          width: "100px",
        },
      ];
    },
    isModelProviderAutoFilled() {
      return !!this.platformToProviderMap[this.currentPlatform];
    },
    filteredProviderOptions() {
      if (this.currentPlatform != "Azure") {
        return this.DDProvider;
      }

      return this.DDProvider.filter((provider) => {
        const providerName = this.getProviderName(provider).toLowerCase();
        return providerName != "google" && providerName != "other";
      });
    },
    showApiVersionField() {
      return this.isAnthropicSelection(this.currentPlatform, this.currentProvider);
    },
    imageQualityOptions() {
      const modelName = (this.currentModelName || "").toLowerCase();
      // GPT-Image uses "high" and "low" values
      if (modelName.includes("gpt-image") || modelName.includes("gpt-4o-image")) {
        return [
          { text: "HD", value: "high" },
          { text: "Standard", value: "low" },
        ];
      }
      // DALL-E uses "hd" and "standard" values
      return [
        { text: "HD", value: "hd" },
        { text: "Standard", value: "standard" },
      ];
    },
    jsonFormatError() {
      const s = this.JSON_Format;
      if (!s || s.trim() === '') return null;
      try {
        JSON.parse(s);
        return null;
      } catch (e) {
        const posMatch = e.message.match(/position\s+(\d+)/i);
        if (posMatch) {
          const pos = Number.parseInt(posMatch[1]);
          const before = s.substring(0, pos);
          const lines = before.split('\n');
          return { line: lines.length, col: lines[lines.length - 1].length + 1 };
        }
        const lineColMatch = e.message.match(/line\s+(\d+)\s+column\s+(\d+)/i);
        if (lineColMatch) {
          return { line: Number.parseInt(lineColMatch[1]), col: Number.parseInt(lineColMatch[2]) };
        }
        return { line: null, col: null };
      }
    },
  },
  async mounted() {
    this.GetDate();
    await this.GetKeyJSON();
    await this.GetProviderData();
  },
  watch: {
    options: {
      handler() {
        this.GetModelData();
      },
      deep: true,
    },
    CurrentPromptPrice: {
      handler: function (newVal, oldVal) {
        let regex = /^\d*(?:\.\d*)?$/;
        if (!regex.test(newVal) && newVal != null && newVal != "") {
          this.$nextTick(() => {
            this.CurrentPromptPrice = oldVal;
          });
        }
      },
      deep: true,
    },
    CurrentCompletionPrice: {
      handler: function (newVal, oldVal) {
        let regex = /^\d*(?:\.\d*)?$/;
        if (!regex.test(newVal) && newVal != null && newVal != "") {
          this.$nextTick(() => {
            this.CurrentCompletionPrice = oldVal;
          });
        }
      },
      deep: true,
    },
    CurrentImagePrice: {
      handler: function (newVal, oldVal) {
        let regex = /^\d*(?:\.\d*)?$/;
        if (!regex.test(newVal) && newVal != null && newVal != "") {
          this.$nextTick(() => {
            this.CurrentImagePrice = oldVal;
          });
        }
      },
      deep: true,
    },
  },
  methods: {
    openDeleteDialog(item) {
      this.itemToDelete = item;
      this.currentID = item?.id ?? null;
      this.currentModelName = item?.modelName ?? '';
      this.useModelDeleteMessage = '';
      this.showReplacePreview = false;
      this.replacementModelId = null;
      this.modelInUseBots = [];
      this.allDDLModels = [];
      this.dialog = true;
      this.$call.GetModelDataInUse(
        { id: item.id },
        (response) => {
          const status = typeof response?.status === 'string' ? Number(response.status) : response?.status;
          if (status === 0 && response?.data?.isInUse) {
            this.$call.GetDDLModelData(
              (ddlResponse) => {
                this.dialog = false;
                if (ddlResponse.status == 0) {
                  this.allDDLModels = (ddlResponse.data || []).filter(m =>
                    m.id !== item.id &&
                    m.platform === item.platform &&
                    m.provider === item.provider &&
                    m.modelType === item.modelType
                  );
                }
                this.modelInUseBots = response.data.bots || [];
                this.showReplaceDialog = true;
              },
              (err) => {
                this.dialog = false;
                console.error(err);
                this.modelInUseBots = response.data.bots || [];
                this.showReplaceDialog = true;
              }
            );
          } else {
            this.dialog = false;
            this.showDeleteDialog = true;
          }
        },
        (err) => {
          this.dialog = false;
          console.error(err);
          this.showDeleteDialog = true;
        }
      );
    },
    closeDeleteDialog() {
      if (this.deleting) return;
      this.showDeleteDialog = false;
      this.showUseModelDeleteDialog = false;
      this.showReplaceDialog = false;
      this.itemToDelete = null;
      this.useModelDeleteMessage = '';
      this.modelInUseBots = [];
      this.replacementModelId = null;
      this.showReplacePreview = false;
      this.allDDLModels = [];
    },
    isBlank(value) {
      return value === null || value === undefined || String(value).trim() === "";
    },
    isZeroOrInvalidNumber(value) {
      if (this.isBlank(value)) return true;
      const numericValue = Number(value);
      return Number.isNaN(numericValue) || numericValue === 0;
    },
    setRequiredWarning(missingFields = []) {
      this.requiredMissingFields = [...new Set(missingFields)];
      this.showNameRequiredDialog = true;
    },
    clearRequiredWarning() {
      this.requiredMissingFields = [];
      this.showNameRequiredDialog = false;
    },
    getMissingRequiredFields() {
      const missingFields = [];
      const addIfMissing = (label, condition) => {
        if (condition) {
          missingFields.push(label);
        }
      };

      addIfMissing(this.$t("platform"), this.isBlank(this.currentPlatform));
      addIfMissing(this.$t("modelProvider"), this.isBlank(this.currentProvider));
      addIfMissing(this.$t("modelType"), this.isBlank(this.currentModelType));
      addIfMissing(this.$t("displayName"), this.isBlank(this.currentModelDisplay));
      addIfMissing(this.$t("modelName"), this.isBlank(this.currentModelName));
      addIfMissing(this.$t("apiVersion"), this.showApiVersionField && this.isBlank(this.currentAPIVesion));

      if (this.currentPlatform == "Other") {
        addIfMissing(this.$t("endpointUrl"), this.isBlank(this.EndPointURL));
        addIfMissing(this.$t("authenticationHeaderName"), this.isBlank(this.AuthenHeaderName));
        addIfMissing(this.$t("apiKey"), this.isBlank(this.API_Key));
      }

      if (this.currentModelType === "text_to_image") {
        addIfMissing(this.$t("imagePrice"), this.isZeroOrInvalidNumber(this.CurrentImagePrice));
        addIfMissing(this.$t("quality"), this.isBlank(this.currentQuality));
        addIfMissing(this.$t("resolution"), this.isBlank(this.currentResolution));
        addIfMissing(this.$t("responseFormat"), this.isBlank(this.currentResFormat));
      } else {
        addIfMissing(this.$t("inputPrice"), this.isZeroOrInvalidNumber(this.CurrentPromptPrice));
        addIfMissing(this.$t("outputPrice"), this.isZeroOrInvalidNumber(this.CurrentCompletionPrice));
      }

      return [...new Set(missingFields)];
    },
    preventNegative(e) {
      if (e.key === '-' || e.key === 'Subtract' || e.key === '.' || e.key === ',') {
        e.preventDefault();
      }
    },
    isPositiveDecimal(evt) {
      evt = evt || window.event;
      const key = evt.key;

      if (!key || key.length !== 1) {
        return true;
      }

      if (key >= '0' && key <= '9') {
        return true;
      }

      if (key !== '.') {
        evt.preventDefault();
        return false;
      }

      const inputValue = evt.target?.value?.toString() ?? '';
      const selectionStart = evt.target?.selectionStart ?? inputValue.length;
      const selectionEnd = evt.target?.selectionEnd ?? inputValue.length;
      const nextValue = inputValue.substring(0, selectionStart) + key + inputValue.substring(selectionEnd);

      if ((nextValue.match(/\./g) || []).length > 1) {
        evt.preventDefault();
        return false;
      }

      return true;
    },
    validateLlmTimeout() {
      const timeoutValue = this.LlmTimeout;

      this.clearLlmTimeoutError();

      if (timeoutValue == null || timeoutValue === '') {
        return false;
      }

      const parsedTimeout = Number(timeoutValue);
      if (!Number.isFinite(parsedTimeout) || parsedTimeout < 1 || parsedTimeout > 3600) {
        this.errorMessage.LlmTimeout.error = true;
        this.errorMessage.LlmTimeout.message = 'Please enter Timeout Response between 1 and 3600 seconds.';
        return true;
      }

      return false;
    },
    clearLlmTimeoutError() {
      if (!this.errorMessage?.LlmTimeout) {
        return;
      }

      this.errorMessage.LlmTimeout.error = false;
      this.errorMessage.LlmTimeout.message = '';
    },
    adjustNumericField(fieldKey, direction) {
      const step = 1;
      const raw = this[fieldKey];
      const current = raw ? Number(raw) : 0;
      if (Number.isNaN(current)) return;

      this[fieldKey] = String(Math.max(0, Math.floor(current + direction * step)));
    },

    adjustPromptPrice(direction) {
      this.adjustNumericField("CurrentPromptPrice", direction);
    },
    adjustMaxToken(direction) {
      this.adjustNumericField("maxToken", direction);
    },
    adjustOutputPrice(direction) {
      this.adjustNumericField("CurrentCompletionPrice", direction);
    },
    adjustCurrentImagePrice(direction) {
      this.adjustNumericField("CurrentImagePrice", direction);
    },
    
    editMaxToken(direction) {
      this.adjustNumericField("maxToken", direction);
    },
    editInputPrice(direction) {
      this.adjustNumericField("CurrentPromptPrice", direction);
    },
    editOutputPrice(direction) {
      this.adjustNumericField("CurrentCompletionPrice", direction);
    },
    editCurrentImagePrice(direction) {
      this.adjustNumericField("CurrentImagePrice", direction);
    },

    onDragOver(event) {
      event.dataTransfer.dropEffect = "copy";
    },

    onDragLeave(event) {
      event.preventDefault();
      this.dragCounter--;
      if (this.dragCounter === 0) {
        this.isDragOver = false;
      }
    },
    CopyText(text) {
      navigator.clipboard.writeText(text);
      this.showPopup();
    },
    insertJsonValue(itemOrText) {
      const propertyName = this.resolveJsonPropertyName(itemOrText);
      const propertyValue = this.resolveJsonPropertyValue(itemOrText);

      if (!propertyName) {
        return;
      }

      const currentJson = this.parseJsonConfigurationForInsert();
      if (currentJson == null) {
        this.$swal.fire({
          icon: "warning",
          title: this.$t("warning"),
          text: this.$t("_fixJsonBeforeAdd"),
          showConfirmButton: false,
          timer: 1800,
        });
        return;
      }

      currentJson[propertyName] = propertyValue;
      this.JSON_Format = JSON.stringify(currentJson, null, 2);
    },
    parseJsonConfigurationForInsert() {
      if (this.JSON_Format == null || this.JSON_Format.trim() == "") {
        return {};
      }

      try {
        const parsed = JSON.parse(this.JSON_Format);
        return parsed && typeof parsed === "object" && !Array.isArray(parsed) ? parsed : {};
      } catch (error) { //NOSONAR
        // error intentionally ignored — no rethrow required
        return null;
      }
    },
    resolveJsonPropertyName(itemOrText) {
      if (itemOrText && typeof itemOrText === "object" && itemOrText.display) {
        return itemOrText.display;
      }

      const keyText = typeof itemOrText === "string" ? itemOrText : itemOrText?.key;
      const matched = String(keyText || "").match(/\{([^{}]+)\}/);
      return matched ? matched[1] : "";
    },
    resolveJsonPropertyValue(itemOrText) {
      const keyText = typeof itemOrText === "string" ? itemOrText : itemOrText?.key;

      try {
        return JSON.parse(keyText);
      } catch (error) { //NOSONAR
        // error intentionally ignored — no rethrow required
        return keyText ?? "";
      }
    },
    getProviderIcon(provider) {
      const icons = {
        OpenAI: "mdi-robot",
        Google: "mdi-google",
        Anthropic: "mdi-brain",
        Azure: "mdi-microsoft-azure",
        AWS: "mdi-aws",
        Other: "mdi-cloud",
      };
      return icons[provider] || "mdi-cloud";
    },

    getProviderColor(provider) {
      const colors = {
        OpenAI: "success",
        Google: "warning",
        Anthropic: "info",
        Azure: "primary",
        AWS: "orange",
        Other: "grey",
      };
      return colors[provider] || "grey";
    },

    getModelTypeClass(modelType) {
      return modelType === "text_based" ? "text-based" : "text-to-image";
    },
    async GetProviderData() {
      this.dialog = true;
      await this.$call.GetDDLProviderData(
        async (dataResponse) => {
          if (dataResponse.status == 0) {
            this.DDProvider = dataResponse.data;
          } else {
            this.DDProvider = [];
          }
          this.dialog = false;
        },
        (errorResource) => {
          this.dialog = false;
          console.error(errorResource);
        }
      );
    },
    async GetModelData() {
      try {
        this.dialog = true;

        let { page, itemsPerPage, sortBy } = this.options;
        let sortField = null;
        let sortOrder = null;

        if (sortBy && sortBy.length > 0) {
          sortField = sortBy[0].key;
          sortOrder = sortBy[0].order === "desc";
        }
        let temp = {
          page: page,
          perPage: itemsPerPage == -1 ? this.totalTable : itemsPerPage,
          sortDesc: sortOrder,
          sortBy: sortField,
          SearchText: this.searchKeyword != null && this.searchKeyword.trim() !== "" ? this.searchKeyword.trim() : null,
        };
        await this.$call.GetModelData(
          temp,
          (dataResponse) => {
            if (dataResponse.status == 0) {
              this.listDataModel = dataResponse.data.data.map(
                (items, index) => ({
                  ...items,
                  key: index + 1,
                  completionPriceUSD: Number.parseFloat(
                    items.completionPriceUSD || 0
                  ).toFixed(6),
                  promptPriceUSD: Number.parseFloat(items.promptPriceUSD || 0).toFixed(
                    6
                  ),
                  imagePriceUSD: Number.parseFloat(items.imagePriceUSD || 0).toFixed(
                    6
                  ),
                })
              );
              this.totalTable = dataResponse.data.total;
              this.searchTotalTable = dataResponse.data.total;
            } else {
              this.listDataModel = [];
              this.totalTable = 0;
              this.searchTotalTable = 0;
            }
            this.dialog = false;
            this.isFirst = false;
          },
          (errorResource) => {
            this.dialog = false;
            if (errorResource.status != 0) {
              console.error(errorResource);
            }
          }
        );
      } catch (error) { //NOSONAR
        // error intentionally ignored — no rethrow required
      }
    },

    Search() {
      const hasSearch = this.searchKeyword != null && this.searchKeyword.trim() !== "";
      this.isSearch = hasSearch;

      if (this.options?.page !== 1) {
        this.options.page = 1;
        return;
      }

      this.GetModelData();
    },

    async _prepareModelFormSubmit(formRefName) {
      this.clearRequiredWarning();

      if (this.validateLlmTimeout()) {
        this.setRequiredWarning([...this.getMissingRequiredFields(), "Timeout Response"]);
        return false;
      }

      this._clearPricingErrors();

      let formValid = true;
      const form = this.$refs?.[formRefName];
      if (form && typeof form.validate === "function") {
        const res = await form.validate();
        formValid = typeof res === "boolean" ? res : !!res?.valid;
      }

      const pricingValid = this._validatePricingFields();

      if (!formValid || !pricingValid) {
        this.setRequiredWarning(this.getMissingRequiredFields());
        return false;
      }
      if (!this._isModelFormValid()) {
        this.setRequiredWarning(this.getMissingRequiredFields());
        return false;
      }
      if (this._hasInvalidJsonFormat()) {
        this._showJsonFormatWarning();
        return false;
      }
      return true;
    },
    async AddModelData() {
      try {
        if (!(await this._prepareModelFormSubmit("addForm"))) {
          return;
        }
        if (this.isDuplicateModelDisplay()) {
          this.showDuplicateModelDataWarning();
          return;
        }
        this.dialog = true;
        const temp = this._buildAddModelPayload();
        await this.$call.CreateModelData(
          temp,
          (dataResponse) => {
            this._handleCreateModelDataResponse(dataResponse);
          },
          (errorResource) => {
            console.log(errorResource);
            this.dialog = false;
            if (errorResource.status != 0) {
              console.error(errorResource);
            }
          }
        );
      } catch (error) { //NOSONAR
        // error intentionally ignored — no rethrow required
      }
    },
    _clearPricingErrors() {
      if (this.errorMessage?.CurrentCompletionPrice) {
        this.errorMessage.CurrentCompletionPrice.error = false;
        this.errorMessage.CurrentCompletionPrice.message = "";
      }
      if (this.errorMessage?.CurrentPromptPrice) {
        this.errorMessage.CurrentPromptPrice.error = false;
        this.errorMessage.CurrentPromptPrice.message = "";
      }
    },
    _validatePricingFields() {
      let pricingValid = true;
      if (this.currentModelType !== "text_to_image") {
        if (this.isZeroOrInvalidNumber(this.CurrentPromptPrice)) {
          pricingValid = false;
          this.errorMessage.CurrentPromptPrice.error = true;
          this.errorMessage.CurrentPromptPrice.message = "Required";
        }
        if (this.isZeroOrInvalidNumber(this.CurrentCompletionPrice)) {
          pricingValid = false;
          this.errorMessage.CurrentCompletionPrice.error = true;
          this.errorMessage.CurrentCompletionPrice.message = "Required";
        }
      }
      return pricingValid;
    },
    _isModelFormValid() {
      const isOther = this.currentPlatform == "Other";
      const hasModelName = this.currentModelName != null && this.currentModelName.trim() != "";
      const hasModelDisplay = (this.currentModelDisplay != null && this.currentModelDisplay.trim() != "" && !isOther) || isOther;
      const hasProvider = this.currentProvider != null && this.currentProvider.trim() != "";
      const hasPlatform = this.currentPlatform != null && this.currentPlatform.trim() != "";
      const hasEndpoint = (isOther && this.EndPointURL != null && this.EndPointURL.trim() != "") || !isOther;
      const hasAuth = (isOther && this.AuthenHeaderName != null && this.AuthenHeaderName.trim() != "" && this.API_Key != null && this.API_Key.trim() != "") || !isOther;
      return hasModelName && this.isCurrentApiVersionValid() && hasModelDisplay && hasProvider && hasPlatform && hasEndpoint && hasAuth;
    },
    _hasInvalidJsonFormat() {
      return (
        this.currentPlatform == "Other" &&
        this.JSON_Format != null &&
        this.JSON_Format.trim() != "" &&
        !this.isValidJson(this.JSON_Format)
      );
    },
    _showJsonFormatWarning() {
      this.$swal.fire({
        icon: "warning",
        title: this.$t("warning"),
        text: this.$t("_WarningJSONFormat"),
        showConfirmButton: false,
        timer: 1800,
      });
    },
    _buildModelPayloadBase() {
      const temp = {
        ModelName: this.currentModelName == null ? "" : this.currentModelName.trim(),
        APIVersion: this.getCurrentApiVersionForPayload(),
        ModelDisplay: this.currentModelDisplay.trim(),
        Provider: this.currentProvider == null ? "" : this.currentProvider.trim(),
        Platform: this.currentPlatform == null ? "" : this.currentPlatform.trim(),
        EndPointURL: this.EndPointURL == null ? "" : this.EndPointURL.trim(),
        AuthenHeaderName: this.AuthenHeaderName == null ? "" : this.AuthenHeaderName.trim(),
        API_Key: this.API_Key == null ? "" : this.API_Key.trim(),
        UseUploadFile: this.UseUploadFile,
        UseReasoningEffort: this.UseReasoningEffort,
        modelType: this.currentModelType,
        completionPrice: null,
        promptPrice: null,
        imagePriceUSD: null,
        quality: null,
        resolution: null,
        JsonRequest: this.JSON_Format,
        maxToken: this.maxToken == "" ? 4096 : this.maxToken,
        LlmTimeout: this.LlmTimeout === '' ? null : this.LlmTimeout,
        resFormatImage: null,
      };
      if (this.currentModelType === "text_to_image") {
        temp.imagePriceUSD = Number.parseFloat(this.CurrentImagePrice).toFixed(6);
        temp.quality = this.currentQuality;
        temp.resolution = this.currentResolution;
        temp.resFormatImage = this.currentResFormat;
        // Image endpoints do not support reasoning_effort; never persist it for image models
        // (covers both create and update, and clears any stale flag from a text→image type switch).
        temp.UseReasoningEffort = false;
      }
      return temp;
    },
    _buildAddModelPayload() {
      const temp = this._buildModelPayloadBase();
      if (this.currentModelType !== "text_to_image") {
        temp.completionPrice = this.CurrentCompletionPrice;
        temp.promptPrice = this.CurrentPromptPrice;
      }
      return temp;
    },
    _handleCreateModelDataResponse(dataResponse) {
      if (dataResponse.status == 0) {
        this.dialog = false;
        if (dataResponse.data == "Data is duplicate") {
          this.$swal.fire({
            icon: "warning",
            title: this.$t("warning"),
            text: dataResponse.data,
            showConfirmButton: false,
            timer: 1800,
          });
        } else {
          this.successMessage = this.$t("modelAddedSuccess");
          this.showSuccess = true;
          clearTimeout(this._toastTimer);
          this._toastTimer = setTimeout(() => {
            this.showSuccess = false;
          }, 3000);
          this.AdddialogUser = false;
          this.totalTable = this.totalTable + 1;
          this.GetModelData();
        }
      } else {
        this.AdddialogUser = false;
        this.dialog = false;
      }
    },
    async UpdateModelData() {
      try {
        if (!(await this._prepareModelFormSubmit("editForm"))) {
          return;
        }
        if (!this.isDuplicateModelDisplay(this.currentID)) { //NOSONAR
          this.dialog = true;
          const temp = this._buildUpdateModelPayload();
          await this.$call.UpdateModelData(
            temp,
            (dataResponse) => {
              this._handleUpdateModelDataResponse(dataResponse);
            },
            (errorResource) => {
              this.dialog = false;
              if (errorResource.status != 0) {
                console.error(errorResource);
              }
            }
          );
        } else {
          this.showDuplicateModelDataWarning();
        }
      } catch (error) { //NOSONAR
        // error intentionally ignored — no rethrow required
      }
    },
    _buildUpdateModelPayload() {
      const temp = { id: this.currentID, ...this._buildModelPayloadBase() };
      if (this.currentModelType !== "text_to_image") {
        temp.completionPrice = Number.parseFloat(this.CurrentCompletionPrice).toFixed(6);
        temp.promptPrice = Number.parseFloat(this.CurrentPromptPrice).toFixed(6);
      }
      return temp;
    },
    _handleUpdateModelDataResponse(dataResponse) {
      if (dataResponse.status == 0) {
        if (dataResponse.data == "Data is duplicate") {
          this.$swal.fire({
            icon: "warning",
            title: this.$t("warning"),
            text: dataResponse.data,
            showConfirmButton: false,
            timer: 1800,
          });
        } else {
          this.successMessage = this.$t("successfullyUpdated");
          this.showSuccess = true;
          clearTimeout(this._toastTimer);
          this._toastTimer = setTimeout(() => {
            this.showSuccess = false;
          }, 3000);
          this.EditdialogUser = false;
          this.dialog = false;
          this.GetModelData();
        }
      } else {
        this.$swal.fire({
          icon: "error",
          title: dataResponse.message,
          showConfirmButton: false,
          timer: 1800,
        });
        this.EditdialogUser = false;
        this.dialog = false;
        this.GetModelData();
      }
      this.dialog = false;
      this.isFirst = false;
    },
    async DeleteModelData() {
      if (!this.itemToDelete || this.deleting) return;
      this.deleting = true;
      const deletedId = this.itemToDelete?.id ?? this.currentID;
      let temp = { id: deletedId };
      this.dialog = true;
      this.showDeleteDialog = false;
      this.showUseModelDeleteDialog = false;
      this.showReplaceDialog = false;
      this.$call.DeleteModelData(
        temp,
          (dataResponse) => {
            this._handleDeleteModelDataResponse(dataResponse, deletedId);
          },
          (errorResource) => {
            this.dialog = false;
            this.deleting = false;
            console.error(errorResource);
          }
      );
    },
    _handleDeleteModelDataResponse(dataResponse, deletedId) {
      const apiStatusRaw = dataResponse?.status ?? dataResponse?.Status;
      const apiStatus = typeof apiStatusRaw === "string" ? Number(apiStatusRaw) : apiStatusRaw;

      if (apiStatus === 0) {
        this._applyDeletedItemLocally(deletedId);
        this.successMessage = this.$t("successfullyDeleted");
        this.showSuccess = true;
        clearTimeout(this._toastTimer);
        this._toastTimer = setTimeout(() => {
          this.showSuccess = false;
        }, 3000);
        if ((this.listDataModel || []).length === 0 && this.options?.page > 1) {
          this.options.page = this.options.page - 1;
        } else {
          this.GetModelData();
        }
        if (typeof this.Clear === "function") {
          this.Clear();
        }
        this.itemToDelete = null;
        this.showDeleteDialog = false;
        this.showUseModelDeleteDialog = false;
      } else if (apiStatus === 1) {
        this.showDeleteDialog = false;
        this.useModelDeleteMessage = Response.message || "This model is in use and cannot be deleted.";
        this.showUseModelDeleteDialog = true;
      } else {
        this.showDeleteDialog = false;
        this.showUseModelDeleteDialog = true;
      }
      this.dialog = false;
      this.deleting = false;
    },
    _applyDeletedItemLocally(deletedId) {
      if (deletedId != null) {
        this.listDataModel = (this.listDataModel || []).filter(
          (x) => x.id !== deletedId
        );
        if (typeof this.searchTotalTable === "number" && this.searchTotalTable > 0) {
          this.searchTotalTable -= 1;
        }
        if (typeof this.totalTable === "number" && this.totalTable > 0) {
          this.totalTable -= 1;
        }
      }
    },
    async ReplaceAndDelete() {
      if (!this.replacementModelId || this.deleting) return;
      this.deleting = true;
      this.dialog = true;
      this.showReplaceDialog = false;
      const deletedId = this.itemToDelete?.id ?? this.currentID;
      this.$call.ReplaceAndDeleteModelData(
        { id: deletedId, replacementID: this.replacementModelId },
        (response) => {
          const apiStatus = typeof response?.status === 'string' ? Number(response.status) : response?.status;
          if (apiStatus === 0) {
            this.listDataModel = (this.listDataModel || []).filter(x => x.id !== deletedId);
            if (typeof this.searchTotalTable === 'number' && this.searchTotalTable > 0) this.searchTotalTable -= 1;
            if (typeof this.totalTable === 'number' && this.totalTable > 0) this.totalTable -= 1;
            this.successMessage = this.$t('_modelReplacedDeleted');
            this.showSuccess = true;
            clearTimeout(this._toastTimer);
            this._toastTimer = setTimeout(() => { this.showSuccess = false; }, 3000);
            if ((this.listDataModel || []).length === 0 && this.options?.page > 1) {
              this.options.page -= 1;
            } else {
              this.GetModelData();
            }
            this.itemToDelete = null;
          } else {
            this.useModelDeleteMessage = response?.message ?? response?.Message ?? 'Failed to replace model.';
            this.showUseModelDeleteDialog = true;
          }
          this.dialog = false;
          this.deleting = false;
        },
        (err) => {
          this.dialog = false;
          this.deleting = false;
          console.error(err);
        }
      );
    },
    Add() {
      this.AdddialogUser = true;
      this.clearRequiredWarning();
      this.clearLlmTimeoutError();
      this.currentModelName = "";
      this.currentAPIVesion = "";
      this.CurrentCompletionPrice = "";
      this.CurrentPromptPrice = "";
      this.currentModelDisplay = "";
      this.currentProvider = null;
      this.currentPlatform = null;
      this.currentModelType = null;
      this.UseUploadFile = false;
      this.UseReasoningEffort = false;
      // Reset new fields
      this.CurrentImagePrice = 0;
      this.currentQuality = "";
      this.currentResolution = "";
      this.currentResFormat = "";
      this.JSON_Format = `{
  "messages":"{messages}"
}`;
      this.EndPointURL = null;
      this.AuthenHeaderName = null;
      this.API_Key = null;
      this.Show_API_Key = false;
    },
    Edit(item) {
      this.EditdialogUser = true;
      this.clearRequiredWarning();
      this.clearLlmTimeoutError();
      this.currentModelName = item.modelName;
      this.currentAPIVesion = item.apiVersion;
      this.CurrentCompletionPrice = item.completionPriceUSD;
      this.CurrentPromptPrice = item.promptPriceUSD;
      this.currentModelDisplay = item.modelDisplay;
      this.currentProvider = item.provider;
      // Reverse map platform from item or use default
      if (item.platform) {
        this.currentPlatform = item.platform;
      } else {
        // Default mapping for legacy data without platform
        const reverseMap = {};
        for (const [platform, provider] of Object.entries(this.platformToProviderMap)) {
          reverseMap[provider] = platform;
        }
        this.currentPlatform = reverseMap[item.provider] || 'Azure';
      }
      this.currentModelType = item.modelType;
      this.UseUploadFile = item.useUploadFile;
      this.UseReasoningEffort = item.useReasoningEffort;
      this.currentID = item.id;
      this.CurrentImagePrice = item.imagePriceUSD || 0;
      this.currentQuality = item.quality || "";
      this.currentResolution = item.resolution || "";
      this.currentResFormat = item.resFormatImage || "";
      this.JSON_Format = item.jsonRequest || "";
      this.EndPointURL = item.endPointURL || "";
      this.AuthenHeaderName = item.authenHeaderName || "";
      this.API_Key = item.apI_Key || "";
      this.Show_API_Key = false;
      this.maxToken = item.maxToken
      this.LlmTimeout = item.llmTimeout ?? null
    },
    Delete(item) {
      if (item) {
        this.openDeleteDialog(item);
        return;
      }
      if (!this.itemToDelete || this.deleting) return;
      this.currentID = this.itemToDelete?.id ?? this.currentID;
      this.currentModelName = this.itemToDelete?.modelName ?? this.currentModelName;
      this.DeleteModelData();
    },
    Close() {
      this.clearRequiredWarning();

      this.errorMessage = {
        CurrentPromptPrice: {
          error: false,
          message: ''
        },
        CurrentCompletionPrice: {
          error: false,
          message: ''
        },
        LlmTimeout: {
          error: false,
          message: ''
        },
      };

      this.AdddialogUser = false;
      this.EditdialogUser = false;
      this.statusDialog = false;
      this.currentModelName = "";
      this.currentID = null;
      this.CurrentCompletionPrice = "";
      this.CurrentPromptPrice = "";
      this.UseUploadFile = false;
      this.UseReasoningEffort = false;
      this.maxToken = ""
      this.LlmTimeout = null
      this.currentPlatform = null;
      this.currentProvider = null;
    },
    CloseStatusDialog() {
      this.statusDialog = false;
    },
    async GetKeyJSON() {
      this.dialog = true;
      await this.$call.GetKeyJSON(
        async (dataResponse) => {
          if (dataResponse.status == 0) {
            this.menuKeyJSON = dataResponse.data;
          } else {
            this.menuKeyJSON = [];
          }
          this.dialog = false;
        },
        (errorResource) => {
          this.dialog = false;
          console.error(errorResource);
        }
      );
    },
    highlighter(code) {
      return highlight(code, languages.js);
    },
    onDrop(event) {
      event.preventDefault();
      const text = event.dataTransfer.getData("text");
      this.insertJsonValue(text);
    },
    onDragStart(event, text) {
      event.dataTransfer.setData("text", text);
    },
    showPopup() {
      this.showClipboardPopup = true;
      setTimeout(() => {
        this.showClipboardPopup = false;
      }, 2000);
    },
    changePlatform(platform) {
      // Auto-fill Model Provider if platform has a direct mapping
      if (this.platformToProviderMap[platform]) {
        this.currentProvider = this.platformToProviderMap[platform];
      } else {
        this.currentProvider = null;
      }
      // Handle "Other" platform logic (Endpoint URL section)
      if (platform == "Other") {
        this.currentModelName = null;
        this.currentAPIVesion = null;
      } else {
        this.EndPointURL = null;
        this.AuthenHeaderName = null;
        this.API_Key = null;
      }
      this.syncApiVersionField();
    },
    changeProvider(Provider) {
      if (this.currentPlatform == "Other") {
        this.currentModelName = null;
        this.currentAPIVesion = null;
      } else {
        this.EndPointURL = null;
        this.AuthenHeaderName = null;
        this.API_Key = null;
      }
      this.syncApiVersionField();
    },
    getProviderName(provider) {
      if (typeof provider == "string") {
        return provider;
      }
      return provider?.providerName || provider?.ProviderName || provider?.value || provider?.text || "";
    },
    isAnthropicName(value) {
      const normalizedValue = String(value || "").trim().toLowerCase();
      return normalizedValue.includes("anthropic") || normalizedValue.includes("claude");
    },
    isAnthropicSelection(platform, provider) {
      return this.isAnthropicName(platform) || this.isAnthropicName(provider);
    },
    isCurrentApiVersionValid() {
      if (!this.showApiVersionField) {
        return true;
      }
      return this.currentAPIVesion != null && this.currentAPIVesion.trim() != "";
    },
    getCurrentApiVersionForPayload() {
      if (!this.showApiVersionField) {
        return null;
      }
      return this.currentAPIVesion == null ? null : this.currentAPIVesion.trim();
    },
    normalizeDuplicateValue(value) {
      return String(value || "").trim().toLowerCase();
    },
    isDuplicateModelDisplay(ignoreId = null) {
      const currentModelDisplay = this.normalizeDuplicateValue(this.currentModelDisplay);
      if (!currentModelDisplay) {
        return false;
      }

      return this.listDataModel.some((item) => item.id != ignoreId && this.normalizeDuplicateValue(item.modelDisplay) == currentModelDisplay);
    },
    showDuplicateModelDataWarning() {
      this.$swal.fire({
        icon: "warning",
        title: this.$t("warning"),
        text: this.$t("dataIsDuplicate"),
        showConfirmButton: false,
        timer: 1800,
      });
    },
    syncApiVersionField() {
      if (!this.showApiVersionField) {
        this.currentAPIVesion = null;
      }
    },
    isValidJson(jsonString) {
      try {
        JSON.parse(jsonString);
        return true;
      } catch (e) { //NOSONAR
        // error intentionally ignored — no rethrow required
        return false;
      }
    },
    beautifyJson() {
      try {
        this.JSON_Format = JSON.stringify(JSON.parse(this.JSON_Format), null, 2);
      } catch (e) { //NOSONAR
        // no-op: button is disabled when JSON is invalid
      }
    },
  },
};
</script>
<style scoped>
.success-toast {
  position: fixed;
  top: 12px;
  left: 50%;
  transform: translateX(-50%);
  background: linear-gradient(100deg,#1C8239,#135928);
  color: #ffffff;
  display: flex;
  align-items: center !important;
  font-size: 14px;
  font-weight: 600;
  border-radius: 12px;
  box-shadow: 0 4px 12px rgba(0,0,0,0.25);
  z-index: 2100;
  width: 50%;
  max-width: 900px;
  min-width: 320px;
  justify-content: center !important;
  padding: 12px;
  border: 1px solid #ffffff;
  gap: 20px;
  margin-top: 110px;
}
.card2 {
  border-radius: 10px !important;
  margin-bottom: 2rem;
}
.action-divider {
  width: 2px;
  height: 40px;
  background: rgba(0, 0, 0, 0.12);
  border-radius: 1px;
}
.products-header-button {
  display: flex;
  flex-direction: row;
  background: linear-gradient(100deg, #C32E0E 0%, #F67760 100%) !important;
  border-radius: 12px;
  width: auto;
  justify-content: center;
  align-items: center;
  gap: 4px;
  padding: 12px;
}
.products-header-button:hover, .models-add-button:hover {
  background: linear-gradient(100deg, #F36243 0%, #FF8E7A 100%) !important;
}
.model-cancel-button {
  display: flex;
  align-items: center !important;
  justify-content: center !important;
  border: 1px solid #949AA8 !important;
  border-radius: 12px;
  width: 100px;
}
.models-add-button {
  display: flex;
  background: linear-gradient(100deg, #C32E0E 0%, #F67760 100%) !important;
  border-radius: 12px;
  width: 100px;
  justify-content: center !important;
  gap: 8px;
  align-items: center !important;
  padding: 8px;
}
:deep(.v-data-table-server) {
  border-radius: 12px;
  overflow: hidden;
  border: 1px solid rgba(0, 0, 0, 0.06);
}
:deep(thead) {
  background-color: #FFE4E1 !important;
  padding: 0 8px;
}
.v-table--has-top :deep(.v-table__wrapper) {
  border-top-left-radius: 12px;
  border-top-right-radius: 12px;
}
:deep(.v-data-table tbody tr) {
  transition: all 0.2s ease;
  border-bottom: 1px solid rgba(0, 0, 0, 0.06);
}

:deep(.v-data-table tbody tr:hover) {
  background: rgba(0, 0, 0, 0.02);
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.08);
}

:deep(.v-data-table-header) {
  background: linear-gradient(135deg, #f8f9fa 0%, #e9ecef 100%);
  border-bottom: 2px solid #dee2e6;
}

:deep(.v-data-table .v-table__wrapper > table > thead > tr th.v-data-table-column--align-left .v-data-table-header__content span) {
  font-weight: 700;
  font-size: 16px;
}
:deep(.v-data-table .v-table__wrapper > table > thead > tr th.v-data-table-column--align-center .v-data-table-header__content span) {
  font-weight: 600;
  font-size: 14px;
}
.delete-dialog-group {
  margin-top: -196px;
}
.delete-dialog-card {
  border-radius: 12px !important;
}
.card-dialog-title {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 8px 16px;
}
.dialog-title {
  margin-top: 8px;
  font-size: 16px;
  color: #C30000 !important;
}
.delete-confirm-btn {
  display: flex;
  align-items: center !important;
  justify-content: center !important;
  gap: 16px;
  border-radius: 12px;
  width: 120px;
  background-color: #C30000;
  margin-right: 8px;
}
.price-display {
  padding: 6px 0;
}
:deep(.model-number-spinner input[type="number"]::-webkit-outer-spin-button),
:deep(.model-number-spinner input[type="number"]::-webkit-inner-spin-button) {
  -webkit-appearance: none;
  margin: 0;
}

.number-arrows {
  display: flex;
  flex-direction: column;
  justify-content: center !important;
  align-items: center !important;
}

.model-input-control :deep(.v-field__append-inner .v-icon) {
  color: #872612 !important;
}
.model-input-control :deep(.v-list .v-list-item--active .v-list-item-title) {
  color: #872612 !important;
  font-weight: 700;
}
.model-input-control :deep(.v-list .v-list-item:hover .v-list-item-title) {
  color: #872612 !important;
}
.model-input-control :deep(.v-field) {
  border: 1px solid #c9c9c9 !important;
  border-radius: 12px !important;
  min-height: 48px;
  box-shadow: none !important;
  background: #ffffff !important;
}
.model-input-control :deep(.v-input__details) {
  display: none;
}
.model-input-control :deep(.v-field__input) {
  padding-top: 13px;
}
.memory-switch :deep(.v-switch__track) {
  background: #a6a6a6 !important;
  border: 1px solid #ffffff !important;
  opacity: 1 !important;
  height: 20px !important;
  width: 32px !important;
  border-radius: 22px !important;
}
.memory-switch :deep(.v-switch__thumb) {
  box-shadow: none !important;
  height: 16px !important;
  width: 16px !important;
  margin-left: 4px !important;
  background-color: #FFFFFF !important;
}
.memory-switch :deep(.v-selection-control--dirty .v-switch__track) {
  background-color: #FFFFFF !important;
  border: 1px solid #C32E0E !important;
  
}
.memory-switch :deep(.v-selection-control--dirty .v-switch__thumb) {
  background-color: #C32E0E !important;
  margin-right: 8px !important;
}
.memory-switch :deep(.v-switch__loader) {
  display: none !important;
}
.additional-option-group {
  display: flex;
  flex-direction: column;
  border-radius: 12px;
  background: #ededed !important;
  padding: 0 12px;
  gap: 8px;
}
.v-menu > .v-overlay__content > .v-card, .v-menu > .v-overlay__content > .v-sheet {
  background: #ffffff !important;
  height: 100%;
  border-radius: 12px;
  max-width: 200px;
  overflow: hidden;
}
.required-name-dialog {
  border-radius: 12px !important;
  background: #FFFFFF;
  border: 1px solid #F4D6B8;
}
.required-name-dialog :deep(.v-divider) {
  border-color: #F4D6B8 !important;
}
.required-name-dialog .close-btn {
  color: #B45800;
}
.required-name-dialog .close-btn:hover {
  color: #8C3F00;
}
.required-name-header {
  background: linear-gradient(900deg,#FFF8ED, #FFF0DA);
  padding: 10px 16px;
  display: flex;
  align-items: center;
  justify-content: space-between;
}
.required-name-title {
  font-size: 16px;
  font-weight: 600;
  color: #FFA726;
}
.required-body {
  padding: 16px;
}
.required-name-message {
  font-size: 14px;
  color: #171717;
}
.required-field-list {
  margin: 10px 0 0;
  padding-left: 22px;
  color: #171717;
  font-size: 14px;
  line-height: 1.7;
}
.required-footer {
  display:flex;
  justify-content:flex-end;
  padding: 10px 26px;
}
.ok-required-btn {
  border-radius: 10px;
  font-weight:500;
  font-size:13px;
  color: #ffffff !important;
  width: 80px;
  background: #9C6411;
  padding: 8px;
}

.flex {
  margin-left: 2rem;
  margin-right: 2rem;
}


:deep(.v-data-table-server__wrapper th) {
  white-space: nowrap;
  vertical-align: middle;
}

:deep(.v-data-table-server__wrapper__wrapper th span) {
  display: inline-flex;
  align-items: center;
  justify-content: center;
}

.rounded-lg {
  border-radius: 8px;
}

.fade-up-enter-active,
.fade-up-leave-active {
  transition: all 0.4s ease;
  max-height: 500px;
  overflow: hidden;
}

.fade-up-enter,
.fade-up-leave-to {
  opacity: 0;
  max-height: 0;
  padding: 0;
  margin: 0;
}

.fade-up-enter-to,
.fade-up-leave {
  opacity: 1;
  max-height: 500px;
}

.price-container {
  display: flex;
  align-items: center;
  padding: 4px 8px;
  border-radius: 4px;
}

.price-content {
  display: flex;
  align-items: center;
  gap: 8px;
  white-space: nowrap;
}

.input-section,
.output-section {
  display: inline-flex;
  align-items: center;
  gap: 4px;
}

.input-section {
  color: var(--v-success-base);
}

.output-section {
  color: var(--v-info-base);
}

.divider {
  color: rgba(0, 0, 0, 0.6);
  margin: 0 4px;
}

.caption {
  font-size: 0.75rem;
  color: rgba(0, 0, 0, 0.6);
}

.image-section {
  display: inline-flex;
  align-items: center;
  gap: 4px;
  color: var(--v-purple-base);
}
.my-editor {
  background: #2d2d2d;
  color: #ccc;
  min-height: 45px;
  font-family: Fira code, Fira Mono, Consolas, Menlo, Courier, monospace;
  font-size: 14px;
  line-height: 1.5;
  padding: 5px;
  padding-top: 10px;
  padding-bottom: 10px;
  border-radius: 10px 10px 10px 10px;
}

.draggable-box {
  background-color: #486BD5;
  border-radius: 5px;
  border: 1px solid #486BD5;
  display: flex;
  justify-content: center;
  align-items: center;
  color: white;
  font-weight: 500;
  font-family: "Roboto", sans-serif;
  font-size: 14px;
  cursor: pointer;
  user-select: none;
  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);
  transition: transform 0.2s, box-shadow 0.2s;
  margin-bottom: 6px;
  padding: 3px;
  padding-left: 12px;
  padding-right: 12px;
  letter-spacing: 1px; /* เพิ่มช่องไฟระหว่างตัวอักษร */
  line-height: 1.6; /* เพิ่มความสูงของบรรทัด */
}

.draggable-box:hover {
  box-shadow: 0 8px 16px rgba(0, 0, 0, 0.2);
  background-color: #378039;
  border: 1px solid #378039;
  color: #fff;
}

.areaDrag {
  border: 1px solid #2d2d2d;
  border-radius: 40px 0px 0px 0px;
  padding-top: 3px;
  background: #2d2d2d;
}

#JSONFormat {
  border-radius: 10px 10px 10px 10px;
  display: grid;
  grid-template-rows: auto 1fr;
}

#JSONFormat .v-speed-dial {
  position: absolute;
}

#JSONFormat .v-btn--floating {
  position: relative;
}

.scrollable-content {
  max-height: 250px !important;
  overflow-y: auto !important;
  display: flex !important;
  flex-direction: column !important;
  align-items: flex-end !important;
  padding-right: 150px !important;
}
.my-editor.is-invalid {
  border: 3px solid red;
  border-radius: 4px;
}
.model-data-container {
  min-height: 100vh;
  background: linear-gradient(135deg, #f5f7fa 0%, #c3cfe2 100%);
  padding: 24px;
}

/* Header */
.page-header {
  margin-bottom: 32px;
}

.header-content {
  display: flex;
  justify-content: space-between;
  align-items: center;
  background: white;
  padding: 28px 32px;
  border-radius: 20px;
  box-shadow: 0 8px 32px rgba(0, 0, 0, 0.08);
}

.header-left {
  display: flex;
  align-items: center;
  gap: 20px;
}

.header-icon {
  background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
  padding: 16px;
  border-radius: 16px;
  display: flex;
  align-items: center;
  justify-content: center;
  box-shadow: 0 8px 24px rgba(102, 126, 234, 0.3);
}

.page-title {
  font-size: 2rem;
  font-weight: 700;
  color: #1e293b;
  margin: 0 0 6px 0;
  line-height: 1.2;
}

.page-subtitle {
  color: #64748b;
  margin: 0;
  font-size: 1rem;
  line-height: 1.4;
}

.header-right {
  display: flex;
  align-items: center;
  gap: 24px;
}

.stats-card {
  background: #f8fafc;
  padding: 16px 24px;
  border-radius: 12px;
  text-align: center;
  border: 1px solid #e2e8f0;
}

.stat-value {
  font-size: 1.5rem;
  font-weight: 700;
  color: #1e293b;
  line-height: 1;
}

.stat-label {
  font-size: 0.75rem;
  color: #64748b;
  font-weight: 500;
  text-transform: uppercase;
  letter-spacing: 0.5px;
}

.date-display {
  display: flex;
  align-items: center;
  color: #64748b;
  font-weight: 500;
}
.main-card {
  border: 1px solid #dcdcdc;
  border-radius: 12px;
  box-shadow: none;
  padding: 8px 16px;
}
.action-bar {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-top: 6px;
}
.search-section {
  width: 300px;
  background: white;
  border: 1px solid #C9C9C9;
  border-radius: 12px;
}
.search-section :deep(.v-field__field) {
  align-items: center;
}
.search-section :deep(input) {
  padding-top: 0 !important;
  padding-bottom: 0 !important;
  line-height: 20px;
  min-height: 40px;
  display: flex;
  align-items: center;
  font-size: 13px;
}
.header-text-content {
  padding: 8px 16px !important;
  width: 100%;
}
.dialog-header-title {
  color: #171717;
  font-weight: 600;
}
.dialog-text {
  color: #646464;
  font-size: 13px;
}
hr {
  border: none;
  border-top: 1px solid #c9c9c9;
}

.search-input :deep(.v-field) {
  border-radius: 12px;
  background: white;
}

.add-button {
  box-shadow: 0 4px 12px rgba(102, 126, 234, 0.4);
  border-radius: 12px;
  text-transform: none;
  font-weight: 600;
}

.add-button:hover {
  transform: translateY(-2px);
  box-shadow: 0 8px 24px rgba(102, 126, 234, 0.6);
}

.table-row {
  transition: all 0.2s ease;
  border-bottom: 1px solid #f1f5f9;
}

.table-row:hover {
  background: #f8fafc;
  transform: translateY(-1px);
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.05);
}

.table-row td {
  padding: 16px;
  vertical-align: middle;
}

.row-number {
  background: #e2e8f0;
  color: #58667A;
  padding: 4px 8px;
  border-radius: 6px;
  font-weight: 600;
  font-size: 0.8125rem;
}

/* Provider Cell */
.provider-cell {
  display: flex;
  align-items: center;
  gap: 12px;
}

.provider-icon {
  background: #f1f5f9;
  padding: 8px;
  border-radius: 8px;
  display: flex;
  align-items: center;
  justify-content: center;
}

.provider-name {
  font-size: 14px;
  color: #171717;
}

/* Model Display */
.model-display {
  display: flex;
  align-items: center;
  gap: 12px;
}

.model-name {
  font-weight: 600;
  color: #1f2937;
}

.model-badge {
  padding: 2px 8px;
  border-radius: 12px;
  font-size: 0.75rem;
  font-weight: 600;
  text-transform: uppercase;
  letter-spacing: 0.5px;
}

.model-badge.text-based {
  background: #dcfce7;
  color: #166534;
}

.model-badge.text-to-image {
  background: #fef3c7;
  color: #92400e;
}

/* Model Code */
.model-code {
  background: #f1f5f9;
  color: #475569;
  padding: 6px 10px;
  border-radius: 6px;
  font-family: "Monaco", "Consolas", monospace;
  font-size: 0.8125rem;
  border: 1px solid #e2e8f0;
}

/* API Version */
.api-version {
  background: #e0e7ff;
  color: #3730a3;
  padding: 4px 8px;
  border-radius: 6px;
  font-weight: 600;
  font-size: 0.8125rem;
}

/* Model Type Badge */
.model-type-badge {
  display: flex;
  align-items: center;
  justify-content: center !important;
  padding: 6px;
  gap: 10px;
  border-radius: 20px;
  font-weight: 500;
  font-size: 12px;
  text-transform: uppercase;
  width: 144px;
}

.model-type-badge.text-based {
  background: rgba(255, 167, 38, 0.16) !important;
  color: #5E3A0D;
}

.model-type-badge.text-to-image {
  background: #dfe4f7 !important;
  color: #2E49B0;
}

.price-row {
  display: flex;
  flex-direction: column;
  gap: 4px;
  margin-bottom: 4px;
}

.price-item {
  display: flex;
  align-items: center;
  gap: 6px;
  font-weight: 600;
  font-size: 0.8125rem;
}

.price-item.input {
  color: #059669;
}

.price-item.output {
  color: #0ea5e9;
}

.price-item.image {
  color: #7c3aed;
}

.price-unit {
  font-size: 12px;
  color: #171717;
  font-weight: 500;
  text-transform: uppercase;
  letter-spacing: 0.2px;
}

/* Dialog Styles */

/* Dialog Header */


/* Dialog Content */
.dialog-body {
  padding: 16px;
  max-height: 70vh;
  overflow-y: auto;
}

.section-title {
  font-size: 16px;
  font-weight: 600 !important;
  color: #171717;
}

.section-title.expandable {
  cursor: pointer;
  transition: all 0.2s ease;
  justify-content: space-between;
}

.section-title.expandable:hover {
  color: #3b82f6;
}

.expand-icon {
  transition: transform 0.3s ease;
}

.expand-icon.expanded {
  transform: rotate(180deg);
}

/* Form Grid */
.form-grid {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(250px, 1fr));
  gap: 20px;
}

.form-grid .full-width {
  grid-column: 1 / -1;
}

/* Modern Input */
.modern-input :deep(.v-field) {
  border-radius: 12px;
  background: #fafbfc;
  transition: all 0.2s ease;
}

.modern-input :deep(.v-field__outline) {
  color: #d1d5db;
}

.modern-input :deep(.v-field--focused .v-field__outline) {
  color: #3b82f6;
  border-width: 2px;
}

.modern-input :deep(.v-field--focused) {
  background: white;
  box-shadow: 0 0 0 4px rgba(59, 130, 246, 0.1);
}

.price-suffix {
  font-size: 0.75rem;
  color: #64748b;
  margin-left: 8px;
  font-weight: 500;
  white-space: nowrap;
}

/* Switch Grid */
.switch-grid {
  display: grid;
  gap: 20px;
}

.switch-item {
  display: flex;
  align-items: center !important;
  justify-content: space-between;
}


.switch-content {
  flex: 1;
  margin-right: 8px;
}

.switch-title {
  font-weight: 600;
  color: #1f2937;
  margin-bottom: 4px;
  font-size: 0.9375rem;
}

.switch-description {
  font-size: 14px;
  color: #171717;
}

.json-header {
  cursor: pointer;
  margin-bottom: 16px;
}

.json-info-card {
  background: #f8fafc;
  border: 1px solid #e2e8f0;
  border-radius: 12px;
  padding: 20px;
  margin-bottom: 20px;
}

.json-info-card h4 {
  color: #1f2937;
  font-weight: 600;
  margin-bottom: 12px;
}

.code-example {
  background: #2B2B2C;
  color: #FFFFFF;
  padding: 18px;
  border-radius: 12px;
  border: 1px solid rgba(255, 255, 255, 0.08);
  box-shadow: 0 6px 18px rgba(0, 0, 0, 0.18);
  margin-bottom: 16px;
  overflow-x: auto;
}

.code-example pre {
  margin: 0;
  font-family: "Monaco", "Consolas", monospace;
  font-size: 0.875rem;
  line-height: 1.5;
}

.format-notes {
  margin: 0;
  padding-left: 20px;
}

.format-notes li {
  margin-bottom: 8px;
  color: #171717;
  font-size: 12px;
}

/* JSON Editor */
.json-editor-container {
  position: relative;
  background: #1e293b;
  border-radius: 12px;
  overflow: hidden;
  margin-bottom: 16px;
  border: 2px solid transparent;
  transition: all 0.2s ease;
}

.json-editor {
  font-family: "Monaco", "Consolas", monospace;
  font-size: 0.875rem;
  line-height: 1.6;
  min-height: 200px;
  margin-top: 50px;
}

.json-editor.error {
  border: 2px solid #ef4444;
  background: #1e293b;
}

.json-tools {
  position: absolute;
  top: 12px;
  right: 16px;
  display: flex;
  gap: 8px;
}
.json-tool-btn {
  display: flex;
  align-items: center;
  justify-content: center !important;
  border-radius: 12px;
  padding: 8px;
  gap: 6px;
  background: #3859D0;
}
.json-tool-btn:hover {
  opacity: 0.7;
}
.json-tool-btn:disabled {
  opacity: 0.35;
  cursor: not-allowed;
}
.json-error-line {
  display: flex;
  align-items: center;
  gap: 6px;
  padding: 4px 10px 6px;
  color: #ef4444;
  font-size: 12px;
  font-family: "Monaco", "Consolas", monospace;
}

.json-menu {
  border-radius: 12px;
  box-shadow: 0 10px 40px rgba(0, 0, 0, 0.15);
  background: #ffffff !important;
  max-width: 200px;
  max-height: 300px;
  overflow-y: auto;
  overflow-x: hidden;
}

.json-menu-item {
  padding: 12px 16px;
  transition: all 0.2s ease;
  width: 100%;
  box-sizing: border-box;
}

.json-menu-item:hover {
  background: #f8fafc;
}

/* Error Message */
.error-message {
  display: flex;
  align-items: flex-start;
  gap: 8px;
  background: #fef2f2;
  color: #c62222;
  padding: 12px 16px;
  border-radius: 8px;
  border: 1px solid #fecaca;
  font-size: 0.875rem;
  line-height: 1.4;
}

/* Dialog Actions */
.dialog-actions {
  display: flex;
  justify-content: flex-end;
  gap: 20px;
  padding: 24px 32px;
  background: #f8fafc;
  border-top: 1px solid #e2e8f0;
}

.cancel-btn {
  color: #6b7280 !important;
  font-weight: 500;
}

.save-btn {
  background: linear-gradient(135deg, #326FD4 0%, #1d4ed8 100%) !important;
  color: white !important;
  font-weight: 600;
  box-shadow: 0 4px 12px rgba(59, 130, 246, 0.4);
  border-radius: 12px !important;
  text-transform: none;
}

.save-btn:hover {
  transform: translateY(-1px);
  box-shadow: 0 6px 20px rgba(59, 130, 246, 0.6);
}

/* Loading Overlay */
.loading-overlay :deep(.v-overlay__scrim) {
  background: rgba(255, 255, 255, 0.9) !important;
  backdrop-filter: blur(8px);
}

.loading-content {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 16px;
  background: white;
  padding: 32px;
  border-radius: 16px;
  box-shadow: 0 20px 40px rgba(0, 0, 0, 0.1);
}

/* Transitions */
.fade-slide-enter-active,
.fade-slide-leave-active {
  transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
}

.fade-slide-enter-from {
  opacity: 0;
  transform: translateY(-8px);
  max-height: 0;
  overflow: hidden;
}

.fade-slide-leave-to {
  opacity: 0;
  transform: translateY(8px);
  max-height: 0;
  overflow: hidden;
}

/* Responsive Design */
@media (max-width: 1024px) {
  .form-grid {
    grid-template-columns: 1fr;
  }

  .header-content {
    flex-direction: column;
    gap: 20px;
    text-align: center;
  }

  .action-bar {
    flex-direction: column;
    gap: 16px;
  }

  .search-section {
    margin-right: 0;
    max-width: none;
  }
}

@media (max-width: 768px) {
  .model-data-container {
    padding: 16px;
  }

  .header-content {
    padding: 20px 24px;
  }

  .page-title {
    font-size: 1.5rem;
  }

  .action-bar {
    padding: 16px 20px;
  }

  .dialog-body {
    padding: 8px 16px;
  }

  .dialog-actions {
    padding: 16px 20px;
  }

  .modern-table :deep(thead th),
  .table-row td {
    padding: 12px 8px;
  }
}
.header-icon-container.edit-mode {
  background: linear-gradient(135deg, #f59e0b 0%, #d97706 100%);
}

/* Enhanced Form Validation */
.modern-input.error :deep(.v-field) {
  border-color: #ef4444 !important;
}

.modern-input.error :deep(.v-field__outline) {
  color: #ef4444 !important;
  border-width: 2px !important;
}

/* Enhanced Tooltips */
.v-tooltip :deep(.v-overlay__content) {
  background: #1f2937 !important;
  color: white !important;
  border-radius: 8px !important;
  padding: 8px 12px !important;
  font-size: 0.8125rem !important;
  max-width: 250px !important;
  text-align: center !important;
}

.json-editor-container:focus-within {
  border-color: #3b82f6;
  box-shadow: 0 0 0 4px rgba(59, 130, 246, 0.1);
}

.json-editor-container.error {
  border-color: #ef4444;
  box-shadow: 0 0 0 4px rgba(239, 68, 68, 0.1);
}

/* Loading State for Save Button */
.save-btn.v-btn--loading {
  pointer-events: none;
  animation: pulse 1.5s ease-in-out infinite;
}

.save-btn .v-btn__loader {
  color: white;
}

/* Form Section Spacing */
.form-section:last-child {
  margin-bottom: 0;
}

/* Dialog Content Scrollbar */
.dialog-body::-webkit-scrollbar {
  width: 8px;
}

.dialog-body::-webkit-scrollbar-track {
  background: #f1f5f9;
  border-radius: 4px;
}

.dialog-body::-webkit-scrollbar-thumb {
  background: #cbd5e1;
  border-radius: 4px;
}

.dialog-body::-webkit-scrollbar-thumb:hover {
  background: #94a3b8;
}

.fade-slide-enter-to,
.fade-slide-leave-from {
  opacity: 1;
  transform: translateY(0);
  max-height: 500px;
}

/* Dialog Responsiveness */
@media (max-width: 768px) {
  .header-info {
    gap: 16px;
  }

  .dialog-title {
    font-size: 1.25rem;
  }

  .dialog-text {
    font-size: 12px;
  }

  .dialog-body {
    padding: 8px 16px;
  }

  .form-grid {
    grid-template-columns: 1fr;
    gap: 16px;
  }

  .dialog-actions {
    padding: 16px;
    flex-direction: column-reverse;
    gap: 8px;
  }

  .save-btn,
  .cancel-btn {
    width: 100%;
    justify-content: center;
  }
}

@media (max-width: 640px) {
  .header-icon-container {
    padding: 12px;
  }

  .header-icon-container .v-icon {
    font-size: 20px !important;
  }

  .section-title {
    font-size: 1rem;
  }

  .json-info-card {
    padding: 16px;
  }

  .code-example {
    padding: 12px;
    font-size: 0.8125rem;
  }

  .json-tools {
    position: relative;
    top: auto;
    right: auto;
    margin-top: 12px;
    text-align: center;
  }
}

/* Loading Animation */
@keyframes pulse {
  0%,
  100% {
    opacity: 1;
  }
  50% {
    opacity: 0.5;
  }
}

/* Success State */
.form-section.success {
  background: #f0fdf4;
  border: 1px solid #bbf7d0;
  border-radius: 12px;
  padding: 16px;
  margin-bottom: 24px;
}

.form-section.success .section-title {
  color: #171717;
}

.draggable-item {
  cursor: grab;
  transition: all 0.2s ease;
  position: relative;
}

.draggable-item:hover {
  background: #f8fafc;
}

.draggable-item:active {
  cursor: grabbing;
}

.draggable-item :deep(.v-list-item__append) {
  opacity: 0;
  transition: opacity 0.2s ease;
}

.draggable-item:hover :deep(.v-list-item__append) {
  opacity: 1;
}

/* Drop Zone Indicator */
.json-editor::before {
  content: "";
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: linear-gradient(
    45deg,
    transparent 25%,
    rgba(59, 130, 246, 0.1) 25%,
    rgba(59, 130, 246, 0.1) 50%,
    transparent 50%,
    transparent 75%,
    rgba(59, 130, 246, 0.1) 75%
  );
  background-size: 20px 20px;
  opacity: 0;
  pointer-events: none;
  transition: opacity 0.3s ease;
}

.json-editor.drag-over::before {
  opacity: 1;
}

/* Insert Notification */
.insert-notification {
  position: fixed;
  top: 20px;
  right: 20px;
  background: #0B855D;
  color: white;
  padding: 12px 20px;
  border-radius: 8px;
  box-shadow: 0 8px 24px rgba(16, 185, 129, 0.3);
  z-index: 9999;
  font-weight: 500;
  transform: translateX(0);
  transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
}

.insert-notification.fade-out {
  opacity: 0;
  transform: translateX(100px);
}

.json-menu-item :deep(.v-list-item-title) {
  display: block;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

/* Scrollbar for JSON Menu */
.json-menu::-webkit-scrollbar {
  width: 6px;
}

.json-menu::-webkit-scrollbar-track {
  background: #f1f5f9;
  border-radius: 3px;
}

.json-menu::-webkit-scrollbar-thumb {
  background: #cbd5e1;
  border-radius: 3px;
}

.json-menu::-webkit-scrollbar-thumb:hover {
  background: #94a3b8;
}
.credentials-row {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 20px;
  margin-bottom: 20px;
}

@media (max-width: 768px) {
  .credentials-row {
    grid-template-columns: 1fr;
  }
}

/* Responsive adjustments */
@media (max-width: 768px) {
  .insert-notification {
    top: 10px;
    right: 10px;
    left: 10px;
    font-size: 0.875rem;
  }
}
</style>
